/*
 * COPYRIGHT 2011 Jobvite, Inc. All rights reserved. This copyright notice is Copyright Management
 * Information under 17 USC 1202 and is included to protect this work and deter copyright infringement.
 * Removal or alteration of this Copyright Management Information without the express written permission
 * of Jobvite, Inc. is prohibited, and any such unauthorized removal or alteration will be a violation of
 * federal law.
 */
const { addGhostText } = require('../../candidates/details/jv.friendWidgetMin.webpack.js');

var JV = window.JV || {};
var i18n = window.i18n || {};
/**
 *
 * @param id: id of the filter.
 *
 * @return callback: any callback that needs to be called when the change event happens.
 *
 */
function Filter(id, className, identifier, defaultCallback) {
    this.id = id;
    this.actionMapper = {};
    this.className = className;
    this.identifier = identifier;
    this.elementSelect = (identifier == 'id') ? '#' + id : '.' + className;
    this.defaultCallback = defaultCallback ? defaultCallback : function () { };
}

Filter.prototype = {
    /**
     * Will be required only when we need to dynamically inject the dropdown from the javascript.
     */
    initialize: function () {
        this.attachEvent();
    },

    /**
     * For each value change you can add the action for that value within that drop down. Also specify the callback to be called.
     */
    addAction: function (value, action, callback) {
        this.actionMapper[value] = {};
        this.actionMapper[value].action = action;
        this.actionMapper[value].callback = callback;
    },

    /**
     *** Attaching events to the element based on the class/id attribute.
     **/
    attachEvent: function () {
        var me = this,
            element = $(this.elementSelect);
        element.on('click', function (event) {
            event.stopPropagation();
        });
        element.on('change', function () {
            var selectedValue = $(this).val();
            if (me.actionMapper[selectedValue] && me.actionMapper[selectedValue].action && me.actionMapper[selectedValue].callback) {
                me.actionMapper[selectedValue].callback();
            } else {
                me.defaultCallback();
            }
        });

    },

    /**
     * get the selected value of the element.
     */
    getSelection: function () {
        $(this.elementSelect).val();
    },

    /**
     * Used for saved searches. Just pass the value and it will set that selected value.
     */
    setSelection: function (value) {
        $(this.elementSelect).val(value);
    }
};

/**************************************************************************
 *
 * @param  gridId: div id where the grid is contained.
 * @param  formId: which form data to submit when the grid needs to refresh.
 *************************************************************************/
function Grid(gridId, formId) {
    this.gridId = gridId;
    this.formId = formId;
}

Grid.prototype = {

    initialize: function () {
        this.attachEvent();
    },

    attachEvent: function () {

    },

    Const: {
        'LOADING': i18n['JV_APPLICANT_LOADING'],
        'PROCESSING': i18n['JV_APPLICANT_PROCESSING']
    },

    /**
     * This can be called from anywhere from the UI using
     * JV.Person.Global.grid.makeCallForGrid();
     */
    makeCallForGrid: function (callback) {
        this.showLoadingState();
        if (!callback) {
            callback = function () { };
        }
        var me = this;
        $('#' + this.formId).on('submit', function () {
            // So that we dont send the default values to the backend.
            JV.Person.removeFadedText();
            //Vinoth: Added for DB optimized querying, if no value is set an empty value
            // will be passed to the BE and the default value of 'FALSE' will be taken from
            //the ApplicationFilter.
            $('#jv-updateFetch').val($('#jv-search').data('updateFetch'));
            var _callback = function () {
                $('#jv-search').data('updateFetch', false);
                callback();
            };
            dataString = $(this).serialize();
            JV.Util.makeAjaxRequest({
                type: 'POST',
                url: JV.AJAX_URL,
                data: dataString,
                ajaxType: 'initialize',

                complete: function () {
                    me.removeLoadingState();
                    // After the call is made reset the page to 0, it will be set each time when the next/previous
                    // page call is made and is not required for the searches which is by default 0.
                    $('#' + JV.Person.elementConst['PAGE_ELEMENT']).val(0);
                    // Also reset the values for the drop downs.
                    JV.Person.resetValues();
                    _callback();
                },

                dataFilter: function (data) {
                    me.renderGrid(data);
                }
            });
            return false;
        });
        $('#' + this.formId).submit();
        // adding the default values to the UI.
        JV.Person.addFadedText();
        $('#' + this.formId).off('submit');
    },

    renderGrid: function (data) {
        //$('#'+this.gridId).html(data);
        // It comes from the backend every time.
        $('#jv-appliedToOverlay').remove();
        var _width = $('#' + this.gridId).width();
        $('#' + this.gridId).replaceWith(data);
        $('#' + this.gridId).css({ 'width': _width + 'px' });
    },

    showLoadingState: function () {
        var template = '<center style="position:absolute;"><img src="/__assets__/images/ajax-loader.gif" style="padding-top: 50%"/></center>';
        JV.Modal.show(template);
    },

    showProcessingState: function () {
        this.showLoadingState();
    },

    removeLoadingState: function () {
        JV.Modal.hide();
    }
};

JV.Person = {
    mode: null,
    searchKeyword: '',
    quickViewChangeStatus: null,
    emailWidgetData: '',
    Const: {
        'CANDIDATE_SELECT_ERROR': i18n['JV_APPLICANT_PLEASE_SELECT_ONE_OR_MORE_CANDIDATES_'],
        'REQUISITION_SELECT_ERROR': i18n['JV_APPLICANT_PLEASE_FILTER_ON_A_REQUISITION_TO_PERFORM_THIS_ACT'],
        'REQUISITION_STATUS_SELECT_ERROR': i18n['JV_APPLICANT_PLEASE_FILTER_ON_A_REQUISITION_AND_STATUS_TO_PERFO'],
        'ENTER_LOCATION': i18n['JV_APPLICANT_ENTER_ZIP_CODE_OR_CITY'],
        'ENTER_COMPANY': i18n['JV_APPLICANT_CURRENT_COMPANY'],
        'ENTER_TITLE': i18n['JV_APPLICANT_CURRENT_TITLE'],
        'ENTER_EDUCATION': i18n['JV_APPLICANT_ENTER_SCHOOL_DEGREE_OR_MAJOR'],
        'ENTER_SEARCH_TEXT': i18n['JV_APPLICANT_ENTER_KEYWORD_OR_NAME'],
        'SEARCH_SUCCESS': i18n['JV_APPLICANT__SEARCH_SAVED_SUCCESSFULLY'],
        'NAME_CONSTRAINTS': i18n['JV_APPLICANT_NAME_MUST_BE_MADE_UP_OF_LETTERS_AND_OR_NUMBERS_AND'],
        'LOADING': i18n['JV_APPLICANT_LOADING_'],
        'SEARCH_NAME_EXITS': i18n['JV_APPLICANT_SEARCH_NAME_ALREADY_EXISTS_PLEASE_CREATE_A_UNIQUE_'],
        'DELETE_SUCCESSFUL_SINGLE': i18n['JV_APPLICANT_CANDIDATE_DELETED_SUCCESSFULLY'],
        'DELETE_SUCCESSFUL_MULTIPLE': i18n['JV_APPLICANT_CANDIDATES_DELETED_SUCCESSFULLY'],
        'CANDIDATE_ADDED_TO_REQ': i18n['JV_APPLICANT_CANDIDATE_WAS_ADDED_TO_REQUISITION'],
        'CANDIDATES_ADDED_TO_REQ': i18n['JV_APPLICANT_CANDIDATES_WERE_ADDED_TO_REQUISITION'],
        'SUBMIT_HM_SINGLE': i18n['JV_APPLICANT_CANDIDATE_SUBMITTED'],
        'SUBMIT_HM_MULTIPLE': i18n['JV_APPLICANT_CANDIDATES_SUBMITTED_SUCCESSFULLY'],
        'COLLECTION_NAME_REQUIRED': i18n['JV_APPLICANT_COLLECTION_NAME_IS_REQUIRED'],
        'SUBJECT_REQUIRED': i18n['JV_APPLICANT_SUBJECT_IS_REQUIRED'],
        'MESSAGE_REQUIRED': i18n['JV_APPLICANT_MESSAGE_IS_REQUIRED'],
        'EMAIL_REQUIRED': i18n['JV_APPLICANT_SELECTED_CANDIDATE_S_DOESN_T_HAVE_EMAIL_ID_'],
        'SELECT_DIFFERENT_JOB': i18n['JV_APPLICANT_SELECT_DIFFERENT_JOB'],
        'SEARCH_NAME_SELECT_ERROR': i18n['JV_APPLICANT_SELECT_A_SEARCH_NAME_TO_PERFORM_SEARCH_'],
        'COLLECTION_NAME_SELECT_ERROR': i18n['JV_APPLICANT_SELECT_A_COLLECTION_NAME_TO_PERFORM_SEARCH_'],
        'INVITE_SENT': i18n['JV_APPLICANT_INVITE_SENT'],
        'ADD_TO_COLLECTION_SUCCESSFUL': i18n['JV_APPLICANT_ADDED_TO_COLLECTION_SUCCESSFULLY'],
        'CHANGE_STATUS_SUCCESSFUL': i18n['JV_APPLICANT_CANDIDATE_STATUS_UPDATED_SUCCESSFULLY'],
        'REJECT_SUCCESSFUL_SINGLE': i18n['JV_APPLICANT_CANDIDATE_HAS_BEEN_REJECTED'],
        'REJECT_SUCCESSFUL_MULTIPLE': i18n['JV_APPLICANT_CANDIDATES_HAVE_BEEN_REJECTED'],
        'NOTES_ADDED_SUCCESSFULLY': i18n['JV_APPLICANT_NOTE_ADDED_SUCCESSFULLY']
    },

    Global: {
        filterObjects: {}
    },

    elementConst: {
        URL_REFRESH: 'jv-urlRefresh',
        REQUISITION_ELEMENT: 'requisitions',
        SEARCH_REQUISITION_ELEMENT: 'jv-selectJobStatus',
        OFCCP_ELEMENT: 'jv-selectJobLink',
        OFCCP_RADIO: 'jv-ofccpJobId',
        SELECT_COLLECTION_ELEMENT: 'jv-selectCollection',
        ADD_NEW_COLLECTION_ELEMENT: 'jv-addNewCollection',
        ADD_COLLECTION: 'jv-addNewCollectionArea',
        SEARCH_ELEMENT: 'jv-searchButtonTop',
        SEARCH_TEXT_ELEMENT: 'jv-requisitionText',
        SEARCH_NAME_TEXT_ELEMENT: 'renameSavedSearch',
        SELECTED_JOBID: 'jobIds',
        ACTIONS_COMBO_ELEMENT: 'jv-actionsCombo',
        ERROR_ELEMENT: 'jv-selectError',
        SELECTED_JOB_ELEMENT: 'jv-jobId',
        CANDIDATE_IDS: 'candidateIds',
        CANDIDATE_GRID: 'jv-searchCandidateGrid',
        SELECTION_MSG_ELEMENT: 'jv-selectionMsg',
        SUCCESS_MSG_ELEMENT: 'jv-successMessage',
        CHANGE_STATUS_ELEMENT: 'jv-changeStatus',
        SAVED_SEARCH: 'jv-savedSearch',
        CANDIDATE_ID_ELEMENT: 'jv-candidateId',
        HIRING_MANAGER_ELEMENT: 'jv-managerName',
        MAIL_SUBJECT_ELEMENT: 'jv-mailSubject',
        MAIL_CONTENT_ELEMENT: 'jv-mailContent',
        SAVED_SEARCH_NAME_ELEMENT: 'jv-searchName',
        NAME_OR_KEYWORDS_SEARCH_ELEMENT: 'jv-name_or_keywords',
        WORKFLOWSTATEIDS_ELEMENT: 'jv-workflowStateIds',
        STATUSES_ELEMENT: 'jv-statuses',
        JOB_TYPES_ELEMENT: 'jv-jobTypes',
        SOURCEIDS_ELEMENT: 'jv-sourceIds',
        SAVED_COLLECTIONS_ELEMENT: 'saved_collections',
        DISTANCE_ELEMENT: 'jv-distance',
        SELECTED_SOURCE: 'jv-sourceSelections',
        SELECTED_REQUISITION: 'jv-requisitionSelections',
        SELECTED_JOBTYPE: 'jv-jobTypeSelections',
        SELECTED_STATUSES: 'jv-workflowStateSelections',
        SELECTED_DISTANCE: 'jv-distanceSelections',
        SELECTED_COLLECTION: 'jv-collectionSelections',
        PAGE_ELEMENT: 'jv-page',
        ALL_CHECKBOX: 'checkboxAll',
        CLEARALL_CHECKBOX: 'clearAll',
        SEARCH_OPTIONS_ELEMENT: 'jv-searchOptions',
        PAGE_NUMBER: 'jv-pageNum',
        OVERLAY_SORTBY: 'jv-overlaySortBy',
        SORT_VALUE_ELEM: 'sortBy',
        SEARCH_OPTION_PANEL: 'jv-option',
        SEARCH_OPTION_IMAGE: 'jv-optionsImg',
        SELECTED_NUMBER_ELEM: 'number',
        FILTERBY_PANEL_CONTENT: 'jv-panelFilter',
        RENAME_SAVED_SEARCH_LINK: 'jv-renameLink',
        DELETE_SAVED_SEARCH_LINK: 'jv-deleteLink',
        DELETE_COLLECTION_NAME_LINK: 'jv-collectionDeleteLink',
        SELECT_COLLECTION: 'jv-selectCollectionSelect',
        VIEW_REQUISITION: 'jv-requiistionView',

        SELECT_COLLECTION_INPUT: 'jv-selectCollectionInput',
        SELECTION_HEADER: 'jv-selectionHeader',
        QUERY_TEXTAREA: 'q',
        SEARCH_COMPANY: 'jv-company',
        SEARCH_TITLE: 'jv-title',
        SEARCH_EXPERIENCE: 'jv-experience',
        SEARCH_EDUCATION: 'jv-education',
        SEARCH_CHECKALL: 'searchAll',
        SEND_OFFER_LETTER: 'sendOfferLetter',
        SAVE_SEARCH_LINK: 'jv-saveSearchLink',
        SEARCH_LIST_FORM: 'jv-searchListForm',
        SELECTED_REQUISITION_ID: 'jv-requisitionId',
        LOCATION_ELEMENT: 'jv-location',
        SELECTED_JOB_DESCRIPTION: 'jv-selectedJobDescription',
        MESSAGE_SUBJECT: 'jv-mailSubject',
        MESSAGE_CONTENT: 'jv-mailContent',
        MESSAGE_ERROR: 'jv-SearchError',
        REJECT_EMAIL_ELEMENT: 'jv-rejectEmail',
        REJECT_EMAIL_SECTION: 'jv-rejectEmailSection',

        //Vinoth: Used when quick views' 'View Candidate' button is clicked.
        QUICK_VIEW_EID: 'jv-quickViewEId',
        QUICK_VIEW_SCRAMBLED_JOBID: 'jv-quickViewScrambledJobId',
        PANEL_HEADER: 'jv-PanelHeader'
    },

    element: {

    },

    /**
     *** Function to initialize the events into DOM.
     **/
    initialize: function () {
        // Set the ajax settings to traditional, otherwise post calls will break.
        this.attachEvent();
        var _modal = JV.Modal;
        var _person = JV.Person;
        var me = this;
        var _util = JV.Util;
        _modal.initialize();

        var grid = new Grid('jv-candidatesGrid', 'jv-searchListForm');
        grid.initialize();
        this.Global['grid'] = grid;

        var gridFilters = new Grid('jv-candidatesGrid', 'jobsTable');
        gridFilters.initialize();
        this.Global['gridFilters'] = gridFilters;

        //////////////////////////////////////////////////////////////////////////////////////////////////
        //Event binding for requisition drop down.
        //
        var requisitionFilter = new Filter(this.elementConst['REQUISITION_ELEMENT'], '', 'id');
        requisitionFilter.initialize();
        this.Global['requisitions'] = requisitionFilter;

        ////////////////////////////////////////////////////////////////////////////////////////////////
        //Event binding for saved search drop down.
        //
        var savedSearchFilter = new Filter(this.elementConst['SAVED_SEARCH'], '', 'id');
        savedSearchFilter.initialize();
        savedSearchFilter.addAction('2', 'renderSavedSearch', function () {
            var key = $('#' + me.elementConst['SAVED_SEARCH'] + ' option:selected').attr('key');
            me.submitWithoutChangeUrl('SEARCH', key);
        });

        this.Global['savedSearch'] = savedSearchFilter;
        //////////////////////////////////////////////////////////////////////////////////////////////////
        //  For Candidates drop down.
        //
        //Event binding for action drop down's change status.
        var actionsFilter = new Filter('', this.elementConst['ACTIONS_COMBO_ELEMENT'], 'class');
        actionsFilter.initialize();

        //Event binding for action drop down's forward resume
        actionsFilter.addAction('1', 'getDeleteActionForm', function () {
            var selectedAppIds = _person.getSelectedAppIds();
            _person.validateSelections('', $('#atsUrl').val() + 'Hiring/ForwardResume.aspx?al=' + selectedAppIds.toString() + '&v=14&rt=' + $('#atsUrl').val() + '/Hiring/Candidates.aspx');
        });

        actionsFilter.addAction('2', 'getChangeStatusForm', function () {
            _person.validateSelections('changeStatusFormOverlay', '');
        });

        actionsFilter.addAction('3', 'getRejectActionForm', function () {
            _person.validateSelections('rejectFormOverlay', '');
        });

        actionsFilter.addAction('4', 'getSendMessageForm', function () {
            _person.validateSelections('sendMessageFormOverlay', '');
        });

        actionsFilter.addAction('5', 'getDeleteActionForm', function () {
            _person.validateSelections('deleteFormOverlay', '');
        });

        actionsFilter.addAction('6', 'getAddToCollectionForm', function () {
            _person.validateSelections('addToCollectionFormOverlay', '');
        });

        //Vinoth: Added for remove from collection functionality.
        actionsFilter.addAction('8', 'getRemoveFromCollectionForm', function () {
            _person.validateSelections('getRemoveFromCollectionFormOverlay', '');
        });

        actionsFilter.addAction('9', 'getSendVideoModalForm', function () {
            _person.validateSelections('getSendVideoModalFormOverlay', '');
        });

        actionsFilter.addAction('10', 'moveCandidate', function () {
            _person.validateSelections('moveCandidateFormOverlay', '');
        });

        actionsFilter.addAction('11', 'sendNoteForm', function () {
            var selectedAppIds = _person.getSelectedAppIds();
            _person.validateSelections('sendNoteFormOverlay', '');
        });


        //Event binding for action drop down's add to requisition
        actionsFilter.addAction('7', 'getDeleteActionForm', function () {
            var selectedAppIds = _person.getSelectedAppIds();
            if (_HRTECHUI_ENABLED === false || window.disableFlags.addToRequisition) {
                //show old modal
                _person.validateSelections('', $('#atsUrl').val() + 'Hiring/CopyCandidate.aspx?al=' + selectedAppIds.toString() + '&v=14&rt=' + $('#atsUrl').val() + '/Hiring/Candidates.aspx');
            } else {
                _person.validateSelections('addCandidateToReqFormOverlay', '');
            }

        });

        JV.Person.Global['gridActions'] = actionsFilter;

        //VA: This is the hack for selecting the previous value when the user clicks on select job and then cancels it. We read the
        // previous value and set it back again to this initial value.
        $('#' + this.elementConst['REQUISITION_ELEMENT']).on('click', function () {
            if ($(this).val() < 0) {
                return;
            }
            $(this).attr('PREVIOUS_VALUE', $(this).val());
        });

        if (jQuery.fn.jquery.split('.')[0] === '3') {
            $('#jv-actionsTop').on('focus', null);
        } else {
            $('#jv-actionsTop').focus();
        }
    },

    /**
     *** Validates the selection of appIds.
     **/
    validateSelections: function (action, linkUrl) {
        var _person = JV.Person;
        var _util = JV.Util;
        var selectedAppIds = _person.getSelectedAppIds();

        if (selectedAppIds.length > 0) {
            //we force the user to select a requisition if selected apps are from different reqs. We want the user to filter first.
            if ((action === 'changeStatusFormOverlay') || (action === 'moveCandidateFormOverlay')) {
                if (_person.getUniqueSelectedApplicationJobIds().length > 1) {
                    _util.showErrorMessage(this.Const['REQUISITION_SELECT_ERROR']);
                    var addReqLink = '<a href="#" id="jv-selectJobLinkJobRelated">' + i18n['JV_APPLICANT_CLICK_TO_SELECT_REQUISITION'] + ' </a>';
                    $('#jv-selectionMsg').append(addReqLink);
                    return false;
                }
                if (!window.disableFlags.skipWorkflow) {
                    if (!_person.getUniqueSelectedStatusValue()) {
                        _util.showErrorMessage(this.Const['REQUISITION_STATUS_SELECT_ERROR']);
                        return false;
                    }
                }
            }

            //if the action is send-message or send video invite then check if any of the candiates has email-id else throw a msg.
            if ((action === 'getSendVideoModalFormOverlay') && !_person.checkForEmail()) {
                _util.showErrorMessage(this.Const['EMAIL_REQUIRED']);
            } else {
                if (action != '') {
                    $('.jv-showErrorMsg').text('').hide();
                    _person.process(action);
                } else {
                    window.location.href = linkUrl;
                }
            }
        } else {
            _util.showErrorMessage(this.Const['CANDIDATE_SELECT_ERROR']);
        }
    },

    /**
     * Get the application Ids from the checkboxes which are selected.
     */
    getSelectedAppIds: function () {
        var me = this;
        var selectedIds = [];
        //VA: for this element we have an id 'checkboxListItems' which is used multiple times within the UI, which is the wrong implementation.
        //Added :enabled to make sure we filter out the disabled inputs.
        var _elem = $('input:checkbox[name=checkboxListItems]:enabled');
        var length = $(_elem).length;
        for (var i = 0; i < length; i++) {
            if ($(_elem[i]).attr('checked'))
                selectedIds.push($(_elem[i]).val());
        }
        return selectedIds;
    },

    /**
     * Get the application Ids from the checkboxes which are selected.
     */
    getUniqueSelectedApplicationJobIds: function () {
        var me = this;
        var selectedJobIds = [];
        var uniqueSelectedJobIds = {};
        //VA: for this element we have an id 'checkboxListItems' which is used multiple times within the UI, which is the wrong implementation.
        var _elem = $('input:checkbox[name=checkboxListItems]');
        var length = $(_elem).length;
        for (var i = 0; i < length; i++) {
            if ($(_elem[i]).attr('checked')) {
                var jobEId = $.trim($(_elem[i]).attr('job'));
                if (uniqueSelectedJobIds.hasOwnProperty(jobEId)) {
                    continue;
                }
                selectedJobIds.push(jobEId);
                uniqueSelectedJobIds[jobEId] = 1;
            }
        }
        return selectedJobIds;
    },

    getUniqueSelectedStatusValue: function () {
        var _elemCheck = $('input:checkbox[name=checkboxListItems]');
        var _value = '';
        var _count = $(_elemCheck).length;
        for (var i = 0; i < _count; i++) {
            //            var _elem = $('.candidateStatusValue').eq(i);
            //            var _elem  = $('.jv-candidateStatus> .tdContainer').children().eq(i);
            var _status = $(_elemCheck[i]).parent().parent().find('.jv-candidateStatus> .tdContainer').children().eq(0).text().trim(); //$.trim($(_elem).text());
            if ($(_elemCheck[i]).attr('checked') && !$(_elemCheck[i]).attr('disabled')) {
                if (!_value) {
                    _value = _status;
                    continue;
                } else if (_value != _status) {
                    _value = '';
                    break;
                }
            }
        }
        return _value;
    },
    /**
     * Get the candidate name from the checkboxes which are selected.
     */
    getSelectedCandidateName: function () {
        var candidateName = '';
        var me = this;
        var _elem = $('input:checkbox[name=checkboxListItems]');
        var length = $(_elem).length;
        for (var i = 0; i < length; i++) {
            if ($(_elem[i]).attr('checked')) {
                candidateName += $(_elem[i]).parent().siblings('.jv-candidateName').text();
            }
        }
        return candidateName.trim();
    },

    /**
     * Checks if any of the selected candidate(s) have a email-id.
     */
    checkForEmail: function () {
        var emailExists = false;
        var _elem = $('input:checkbox[name=checkboxListItems]');
        var length = $(_elem).length;
        for (var i = 0; i < length; i++) {
            if ($(_elem[i]).attr('checked')) {
                if ($.trim($(_elem[i]).attr('email')) == 'true') {
                    emailExists = true;
                    break;
                }
            }
        }
        return emailExists;
    },

    /**
     * Checks if any of the selected candidate(s) have a email-id based on reject candidate Id.
     */
    checkForEmailApIds: function (apIds) {
        var emailExists = false;
        var length = apIds.length;
        for (var i = 0; i < length; i++) {
            if ($.trim($('#' + apIds[i]).attr('email')) == 'true') {
                emailExists = true;
                break;
            }
        }
        return emailExists;
    },

    /**
     * Reset the checkboxes in the grid and only select the row selected by the user. This is per requirement from the Product(confirmed with Chris)
     */
    resetSingleAppIds: function (me, appId) {
        //Vinoth: Modified for quick view, since it's selecting all the checkboxes in grid below check was added.
        if (typeof (appId) == 'undefined') {
            this.togglSelection(false);
            var _element = null;
            if ($('#jv-quickViewEId').length) {
                _element = $("input[id='" + $("#jv-quickViewEId").val() + "']");

            } else {
                //VA: it will not trigger events set up for the checkbox. -> $(me).parentsUntil('tr').parent().find('input:checkbox[name=checkboxListItems]').attr('checked',true).val();
                _element = $(me).parentsUntil('tr').parent().find('input:checkbox[name=checkboxListItems]');
            }
            _element.attr('checked', true);
            $(_element).parentsUntil('tr').parent().find('td').css({ 'background': '#EFF9E4' });
            $('.number').html('1');
        }
    },

    /*
     * Get the single Application/Candidate Id for the selected row.
     * @param: pass the reference of the element in the row.
     */
    getSelectedRowIds: function (me, appId) {
        if (appId && !me) {
            //Vinoth: Modified for quick view, since it's selecting all the checkboxes in grid and sending all the values
            //to webservice call below check was added.
            return { 'applicationId': appId };
        } else if (!appId && me) {
            var appIdElement = $(me).parentsUntil('tr').parent().find('input:checkbox[name=checkboxListItems]');
            return {
                'applicationId': $(appIdElement).val(),
                'candidateId': $(appIdElement).attr('CANDIDATE_EID')
            };
        } else if ((me && appId)) {
            var appIdElement = $(me);
            //Vinoth: Changed as part of getting the id when navigating thru records and changing the actions.
            //Checking for checkbox id since the 'this' attribute changes according to the context.
            //Reviewer Name: Hari, Reviewed on: 3/13/2011
            return {
                'applicationId': (typeof ($(appIdElement).attr('id')) == 'undefined') ? $(appIdElement).val() : $(appIdElement).attr('id')
            };
        } else {
            // there is no appId and no me. Only returns teh applicationId (No candidateId)
            return {
                'applicationId': this.getSelectedAppIds()
            };
        }
    },

    // We dont want to send default string values to the backend. Handle that in the front end only.
    addFadedText: function () {
        var _elementConst = this.elementConst;
        if ($('#' + _elementConst['LOCATION_ELEMENT']).val() == '') {
            $('#' + _elementConst['LOCATION_ELEMENT']).val(this.Const['ENTER_LOCATION']).css('color', '#cccccc');
        }
        if ($('#' + _elementConst['SEARCH_COMPANY']).val() == '') {
            $('#' + _elementConst['SEARCH_COMPANY']).val(this.Const['ENTER_COMPANY']).css('color', '#cccccc');
        }
        if ($('#' + _elementConst['SEARCH_TITLE']).val() == '') {
            $('#' + _elementConst['SEARCH_TITLE']).val(this.Const['ENTER_TITLE']).css('color', '#cccccc');
        }
        if ($('#' + _elementConst['SEARCH_EDUCATION']).val() == '') {
            $('#' + _elementConst['SEARCH_EDUCATION']).val(this.Const['ENTER_EDUCATION']).css('color', '#cccccc');
        }

        if ($('#' + _elementConst['QUERY_TEXTAREA']).val() == '') {
            $('#' + _elementConst['QUERY_TEXTAREA']).val(this.Const['ENTER_SEARCH_TEXT']).css('color', '#cccccc');
        }
    },

    removeFadedText: function () {
        var _elementConst = this.elementConst;
        if ($('#' + _elementConst['LOCATION_ELEMENT']).css('color') == '#cccccc' || $('#' + _elementConst['LOCATION_ELEMENT']).css('color') == 'rgb(204, 204, 204)') {
            $('#' + _elementConst['LOCATION_ELEMENT']).val('');
        }
        if ($('#' + _elementConst['SEARCH_COMPANY']).css('color') == '#cccccc' || $('#' + _elementConst['SEARCH_COMPANY']).css('color') == 'rgb(204, 204, 204)') {
            $('#' + _elementConst['SEARCH_COMPANY']).val('');
        }
        if ($('#' + _elementConst['SEARCH_TITLE']).css('color') == '#cccccc' || $('#' + _elementConst['SEARCH_TITLE']).css('color') == 'rgb(204, 204, 204)') {
            $('#' + _elementConst['SEARCH_TITLE']).val('');
        }
        if ($('#' + _elementConst['SEARCH_EDUCATION']).css('color') == '#cccccc' || $('#' + _elementConst['SEARCH_EDUCATION']).css('color') == 'rgb(204, 204, 204)') {
            $('#' + _elementConst['SEARCH_EDUCATION']).val('');
        }
        if ($('#' + _elementConst['QUERY_TEXTAREA']).css('color') == '#cccccc' || $('#' + _elementConst['QUERY_TEXTAREA']).css('color') == 'rgb(204, 204, 204)') {
            $('#' + _elementConst['QUERY_TEXTAREA']).val('');
        }
    },

    removeColoredText: function () {
        var _elementConst = this.elementConst;
        if ($('#' + _elementConst['LOCATION_ELEMENT']).val() == this.Const['ENTER_LOCATION'] && ($('#' + _elementConst['LOCATION_ELEMENT']).css('color') == '#000000' || $('#' + _elementConst['LOCATION_ELEMENT']).css('color') == 'rgb(0, 0, 0)')) {
            $('#' + _elementConst['LOCATION_ELEMENT']).val('');
        }
        if ($('#' + _elementConst['SEARCH_COMPANY']).val() == this.Const['ENTER_COMPANY'] && ($('#' + _elementConst['SEARCH_COMPANY']).css('color') == '#000000' || $('#' + _elementConst['SEARCH_COMPANY']).css('color') == 'rgb(0, 0, 0)')) {
            $('#' + _elementConst['SEARCH_COMPANY']).val('');
        }
        if ($('#' + _elementConst['SEARCH_TITLE']).val() == this.Const['ENTER_TITLE'] && ($('#' + _elementConst['SEARCH_TITLE']).css('color') == '#000000' || $('#' + _elementConst['SEARCH_TITLE']).css('color') == 'rgb(0, 0, 0)')) {
            $('#' + _elementConst['SEARCH_TITLE']).val('');
        }
        if ($('#' + _elementConst['SEARCH_EDUCATION']).val() == this.Const['ENTER_EDUCATION'] && ($('#' + _elementConst['SEARCH_EDUCATION']).css('color') == '#000000' || $('#' + _elementConst['SEARCH_EDUCATION']).css('color') == 'rgb(0, 0, 0)')) {
            $('#' + _elementConst['SEARCH_EDUCATION']).val('');
        }
        if ($('#' + _elementConst['QUERY_TEXTAREA']).val() == this.Const['ENTER_SEARCH_TEXT'] && ($('#' + _elementConst['QUERY_TEXTAREA']).css('color') == '#000000' || $('#' + _elementConst['QUERY_TEXTAREA']).css('color') == 'rgb(0, 0, 0)')) {
            $('#' + _elementConst['QUERY_TEXTAREA']).val('');
        }
    },

    makeCallForQuickViewOverlayForApplication: function (jId, ceid) {
        elementRef = $("input[candidate_eid='" + ceid + "']");
        $(elementRef).attr('id', jId).attr('value', jId);
        this.process('quickViewFormOverlay', elementRef);
        $('#jv-quickViewLoadingStateWrapper').removeClass('jv-hide').addClass('jv-show');
    },

    makeCallForQuickView: function (eId) {
        elementRef = $("input[value='" + eId + "']");
        this.process('quickViewFormOverlay', elementRef);
    },

    setUpFilterByReqModal: function () {
        var data = {
            filterByReqModal: true
        };
        JV.AngularUtils.broadcast('ADD_TO_REQ_MODAL_CLICKED', data);
        JV.AngularUtils.attachListeners('AddReqModalDataSent', function (event, data) {
            JV.Person.addReqModalData = data;
            JV.Person.process('jobForm', '', null);
        });
    },
    attachEvent: function () {
        var _modal = JV.Modal;
        var _person = this;
        var _elementConst = _person.elementConst;

        // Add Ghost text for the input boxes.
        addGhostText(_elementConst['LOCATION_ELEMENT'], this.Const['ENTER_LOCATION'], 'TEXT');
        addGhostText(_elementConst['SEARCH_COMPANY'], this.Const['ENTER_COMPANY'], 'TEXT');
        addGhostText(_elementConst['SEARCH_TITLE'], this.Const['ENTER_TITLE'], 'TEXT');
        addGhostText(_elementConst['SEARCH_EDUCATION'], this.Const['ENTER_EDUCATION'], 'TEXT');
        addGhostText(_elementConst['QUERY_TEXTAREA'], this.Const['ENTER_SEARCH_TEXT'], 'TEXT');

        //VA: for redirecting to candidate view.
        $('.jv-redirectCandidate').on('click', function () {
            //Vinoth: Setting the jobIds value to hidden field, since while navigating to
            //details page the jobIds param is not getting passed to BE.
            if (typeof ($('select[name=jobIds]').val()) != 'undefined') {
                $('input[name=jobIds]').val($('select[name=jobIds]').val());
            }
            var key = $(this).attr('KEY');
            var args = {};
            args.data = {
                action: 'getCandidateDetailsView',
                page: $('#jv-gridPage').val(),
                ids: key
            };
            // specify the type of request you are sending.
            args.ajaxType = 'redirectCandidate';
            args.success = function (resultList) {
                if (resultList && typeof resultList == 'string') {
                    $('#jv-postData').val(resultList);
                    if ($('#q').val() != _elementConst['ENTER_SEARCH_TEXT']) {
                        $('#jv-viewCandidateForm').append($('<input/>', {
                            type: 'hidden',
                            id: 'jv-keywords',
                            name: 'keywords',
                            value: $('#q').val()
                        }));
                    }
                    $('#jv-viewCandidateForm').submit();
                } else {
                    // Notify the backend that the call failed for some reason.
                }
            };
            JV.Util.makeAjaxRequest(args);
        });


        //VA: Quick View navigation.
        $(document).on('click', '.jv-quickViewNavigation', function () {
            var keyObj = $(this).attr('KEY');
            var typeObj = $(this).attr('NAVIGATION_TYPE');
            // show loading state for the grid.
            if (keyObj == 'MORE') {
                // This is the real number that tells what page is the user on.
                var currentPage = parseInt($('#jv-gridPage').val());
                var page = (typeObj == 'NEXT') ? currentPage + 1 : currentPage - 1;
                // After the grid get loaded it always set to 0.
                $('#jv-page').val(page);
                // refresh the grid here and add a callback.....
                _person.Global.grid.makeCallForGrid(function () {
                    // callback should be able to read next and previous. get the id and then make a call to the makeCallForQuickView with id.
                    var children = $($('#jv-searchCandidateGrid').children()[1]).children();
                    var row = children[0];
                    if (typeObj == 'PREVIOUS') {
                        row = children[children.length - 1];
                    }
                    var eId = $(row).find("input[type='checkbox']").val();
                    _person.makeCallForQuickView(eId);
                });
                return;
            }
            $('#jv-quickViewLoadingStateWrapper').removeClass('jv-hide').addClass('jv-show');
            _person.makeCallForQuickView(keyObj);

        });

        //VA: Quick View trigger.
        $('.jv-infoButton, .allApplications').on('click', function () {
            _person.process('quickViewFormOverlay', this);

        });

        // Only visible if enabled.
        $('#' + _elementConst['OFCCP_ELEMENT'] + ', #' + _elementConst['OFCCP_RADIO']).on('click', function () {
            JV.Person['mode'] = 'OFCCP';
            if (_HRTECHUI_ENABLED === false || window.disableFlags.selectRequisition) {
                _modal.render({
                    action: 'getJobs',
                    //Vinoth: Sending overlay mode to BE, to classify between jobs overlay and OFCCP job overlay while navigating thru pages.
                    overlayMode: JV.Person['mode']
                });

                // if the radio box is checked let it be checked. If not then only check after we set get the jobId from the
                // overlay.
            } else {
                JV.Person.setUpFilterByReqModal();
            }
            return false;
        });

        //Vinoth: Modified the event binding from click to live.
        //Reviewer Name: Hari, Reviewed on: 3/13/2011
        $('#jv-selectJobLinkJobRelated').on('click', function () {
            var selectedOption = $('#' + _elementConst['REQUISITION_ELEMENT']).val();
            if (!selectedOption) {
                $('#' + _elementConst['REQUISITION_ELEMENT']).val('2');
            }
            JV.Person['mode'] = null;
            if (_HRTECHUI_ENABLED === false || window.disableFlags.selectRequisition) {
                _modal.render({
                    action: 'getJobs',
                    jobStateValue: 0,
                    overlayMode: JV.Person['mode']
                });
            } else {
                JV.Person.setUpFilterByReqModal();
            }
            return false;
        });

        $('#jv-recentJobs').on('change', function () {
            $('#' + JV.Person.elementConst['REQUISITION_ELEMENT']).val('2');
            if ($('input:hidden[name=jobIds]').val() != '') {
                $('input:hidden[name=jobIds]').val('');
            }
        });

        //Show/hide reject email section based on the reject email checkbox selection.
        $('#' + this.elementConst['REJECT_EMAIL_ELEMENT']).on('click', function () {
            if (!$(this).attr('checked')) {
                $('#' + _elementConst['REJECT_EMAIL_SECTION']).removeClass('jv-show').addClass('jv-hide');
            } else {
                $('#' + _elementConst['REJECT_EMAIL_SECTION']).removeClass('jv-hide').addClass('jv-show');
            }
        });

        $('#jv-viewAllSearches').on('click', function () {
            _modal.render({
                action: 'getSavedSearchForm'
            });
        });

        $('#' + this.elementConst['LOCATION_ELEMENT']).on('blur', function (e) {
            if ($(this).val() == JV.Person.Const['ENTER_LOCATION']) {
                $(this).css('color', '#cccccc');
            }
            JV.Person.removeFadedText();
            JV.Person.addFadedText();
        });

        $('#' + this.elementConst['LOCATION_ELEMENT']).on('keyup', function (e) {
            if (e.keyCode == 13 || e.which == 13) {
                $('#jv-locationSearch').trigger('click');
            }
        });

        //Vinoth: Added to check the checkbox on click of the text associated with it in the overlay.
        $('.' + this.elementConst['SAVED_SEARCH_NAME_ELEMENT']).on('click', function () {
            $(this).parent().prev().children().attr('checked', 'checked');
        });

        $('.smallcolorlink').on('click', function () {
            $('#q').val('');
        });

        //Vinoth: Function for showing the applications overlay after
        //clicking the '+n more' link.
        /*VA: Now we show quick view so not needed now.
        $('.allApplications').on('click', function(event){
            JV.Person.Global.grid.showLoadingState();
            var _jqObj = $(this);
            var data = { };
            data.action = 'getAllApplications';
            data.ids = $($(this).closest('tr').children()[0]).children().attr('candidate_eid');
            data.eids = $($(this).closest('tr').children()[0]).children().attr('candidate_eid');
            var args = {};
            args.data = data;
            args.ajaxType = 'moreApplicationsClick';
            args.success = function ( content ){
                JV.Person.Global.grid.removeLoadingState();
                //Vinoth: Modified to clear the data before flushing the new contents.
                $('.jv-positionDetails').html('');
                $('#jv-appliedToOverlay').html( content );
                var _position = getScrollXY(_jqObj, $('.jv-positionDetails'));
                $('#jv-appliedToOverlay').css({
                    'left': ( _position[0] - 150 )+'px',
                    'top': _position[1] +'px',
                    'position': 'absolute',
                    'zIndex': 9999,
                    'display':'block'
                });
                $('.jv-positionDetails').mouseover(
                    function(){
                        $(this).show();
                })
                .mouseout(
                    function(){
                        $(this).hide();
                });
                //Vinoth: Modified to close the overlay when cursor moved out of link.
                $('.allApplications').mouseout(
                    function(){
                        $('.jv-positionDetails').hide();
                    });

                $('#jv-appliedToOverlay, .jv-positionDetails').show();
            };
            JV.Util.makeAjaxRequest(args);
        });
        */

        function gridSort() {
            var _sortName = $(this).attr('KEY');
            if (_sortName) {
                var _currentSortBy = $('#' + _elementConst['SORT_VALUE_ELEM']).val();
                if (_sortName == _currentSortBy && _currentSortBy.indexOf('Desc') < 0) {
                    _sortName = _sortName + 'Desc';
                }
                $('#' + _elementConst['SORT_VALUE_ELEM']).val(_sortName);
                _person.Global.grid.makeCallForGrid();
            }
        }

        $('#hr-sortby').find('li').on('click', function () {
            gridSort.call(this);
        });

        // Grid Sorting.
        $('#' + _elementConst['CANDIDATE_GRID']).find('th').on('click', function () {
            gridSort.call(this);
        });

        // For page navigations for the grid.
        $("li[KEY='PREVIOUS'], li[KEY='NEXT']").on('click', function () {
            var navType = $($(this).parent()).attr('navigationType');
            switch (navType) {
                case 'CANDIDATE_GRID':
                    $('#' + _elementConst['PAGE_ELEMENT']).val($(this).attr('page'));
                    JV.Person.Global.grid.makeCallForGrid();
                    break;
                case 'JOBS_GRID':
                    $('#' + _elementConst['PAGE_NUMBER']).val($(this).attr('page'));
                    // TODO: call the getOverlayJob overlay.
                    _person.getOverlayJobs($(this).attr('page'));
                    break;
                default:

            }
        });

        //Greeshma: Select Collections overlay.
        $('.jv-selectCollections').on('click', function () {
            _person.getCollectionsOverlay(0);
        });

        // check or uncheck the checkboxes for the candidates grid.
        $('#' + _elementConst['ALL_CHECKBOX'] + ', #' + _elementConst['CLEARALL_CHECKBOX']).on('click', function () {
            if ($(this).attr('checked')) {
                _person.togglSelection(true);
            } else {
                _person.togglSelection(false);
            }
        });


        // takes care of the select all checkbox and the number of selected checkboxes in the candidates grid.
        $('input:checkbox[name=checkboxListItems]').on('click', function () {
            var numberElem = $('.' + _elementConst['SELECTED_NUMBER_ELEM']);
            var selected = parseInt($(numberElem).html());
            //VA: Expensive
            // $('.'+_elementConst['SELECTED_NUMBER_ELEM']).html($('input:checkbox[name=checkboxListItems]:checked').length);
            if (!$(this).attr('checked')) {
                $('#' + _elementConst['ALL_CHECKBOX']).attr('checked', false);
                $(this).parent().parent().find('td').css({ 'background': '#FFFFFF' });
                selected = selected - 1;
            } else {
                $(this).parent().parent().find('td').css({ 'background': '#EFF9E4' });
                selected = selected + 1;
            }
            $(numberElem).html(selected);
        });


        $('.' + _elementConst['PANEL_HEADER']).on('click', function () {
            //var _headerId = $(this).attr('id');
            //var _itemId = .attr('id');
            var _header = this;
            var _sibling = $(this).next();
            _person.toggleFilters(_header, _sibling);
        });

        /************************** Handling tooltip actions **************************************/

        $(document).on('click', '.jv-tooltipOverlayAction', function () {
            var key = $(this).attr('KEY');
            var next_key = $(this).attr('NEXT_STATE_ID');
            //For Video check the kind and figure out if that is the video screen action of the workflow.
            var next_kind = $(this).attr('next_state_kind');
            var state_id = $(this).attr('id_of_kind');
            switch (key) {
                case 'rejectFormOverlay':
                case 'getSubmitToHiringManagerForm':
                case 'proceedToForm':
                    //Vinoth: Added quickview id to send across for appId selection.
                    var _quickViewId = $('#jv-quickViewEId').val();
                    if (!!_quickViewId) {
                        _person.quickViewChangeStatus = true;
                        // from quick View
                        elementRef = $("input:checkbox[value='" + _quickViewId + "']").parentsUntil('tr').parent();
                        //Picking id value from elementRef
                        var navDetails = _person.getQuickViewNavigationDetails($("input:checkbox[value='" + _quickViewId + "']"));
                        _person.findIdByPosition(navDetails, _quickViewId);
                        if (next_kind === 'VIDEO_SCREEN') {
                            // From quick view.
                            _person.resetSingleAppIds(this);
                            _person.showChangeToVideoWorkflowStateModal(state_id, next_kind, this);
                        } else {
                            _person.process(key, {
                                elemRef: this,
                                id: _quickViewId
                            });
                        }
                    } else {
                        // from grid.
                        _person.resetSingleAppIds(this);
                        // Video Screen needs some set up for templates, and sending video interview so needs to be handled as a special case.
                        if (next_kind === 'VIDEO_SCREEN') {
                            _person.showChangeToVideoWorkflowStateModal(state_id, next_kind, this);
                        } else {
                            _person.process(key, this);
                        }
                    }
                    break;

                case 'schedulePage':
                    if (_HRTECHUI_ENABLED === false || window.disableFlags.newScheduler) {
                        linkUrl = $(this).attr('linkUrl');
                        window.open(linkUrl, 'Jobvite', 'menubar=no,scrollbars=yes,resizable=yes,width=700');
                    } else {
                        JV.Person.Global.grid.showLoadingState();
                        var candidateStateObject = {
                            applicationId: $(this).attr('appid'),
                            stateId: $(this).attr('candidatestateid'),
                            mode: 'schedule'
                        };
                        JV.AngularUtils.broadcast('showScheduler', candidateStateObject);

                    }
                default:
                // do nothing;
            }

        });

        /****************************************************************/

        $('.' + _elementConst['SEND_OFFER_LETTER']).on('click', function () {
            _person.resetSingleAppIds(this);
            _person.process('sendOfferForm');
        });

        // For job overlay actions
        $('#' + _elementConst['SEARCH_ELEMENT']).on('click', function () {
            $('#jv-jobListLoadingStateWrapper').removeClass('jv-hide').addClass('jv-show');
            _person.getOverlayJobs(0);
        });

        $('#' + _elementConst['SEARCH_REQUISITION_ELEMENT']).on('change', function () {
            $('#jv-jobListLoadingStateWrapper').removeClass('jv-hide').addClass('jv-show');
            _person.getOverlayJobs(0);
        });

        $('#' + _elementConst['SEARCH_TEXT_ELEMENT']).on('keyup', function (e) {
            if (e.keyCode == 13 || e.which == 13) {
                $('#jv-jobListLoadingStateWrapper').removeClass('jv-hide').addClass('jv-show');
                _person.getOverlayJobs(0);
            }
        });

        $('#jv-savedSearchText').on('keyup', function (e) {
            if (e.keyCode == 13 || e.which == 13) {
                $('#jv-savedSearchLoadingStateWrapper').removeClass('jv-hide').addClass('jv-show');
                _modal.render({
                    action: 'getSavedSearchForm',
                    q: $(this).val()
                });
            }
        });

        $('#jv-searchSavedSearch').on('click', function () {
            $('#jv-savedSearchLoadingStateWrapper').removeClass('jv-hide').addClass('jv-show');
            _modal.render({
                action: 'getSavedSearchForm',
                q: $('#jv-savedSearchText').val()
            });
        });

        $('#jv-collectionSearchText').on('keyup', function (e) {
            if (e.keyCode == 13 || e.which == 13) {
                $('#jv-collectionLoadingStateWrapper').removeClass('jv-hide').addClass('jv-show');
                _modal.render({
                    action: 'getCollectionsView',
                    q: $(this).val()
                });
            }
        });

        $('#jv-collectionSearchButton').on('click', function () {
            $('#jv-collectionLoadingStateWrapper').removeClass('jv-hide').addClass('jv-show');
            _modal.render({
                action: 'getCollectionsView',
                q: $('#jv-collectionSearchText').val()
            });
        });

        $('#' + _elementConst['SELECT_COLLECTION_INPUT'] + ', #' + _elementConst['SELECT_COLLECTION']).on('keyup', function (e) {
            if (e.keyCode == 13 || e.which == 13) {
                JV.Person.process('addToCollectionForm', '');
            }
        });

        $('.' + _elementConst['RENAME_SAVED_SEARCH_LINK']).on('click', function (event) {
            _person.process('getRenameSavedSearchForm', this, event);
        });

        $('.jv-renameSaveLink').on('click', function (event) {
            _person.process('doRenameSavedSearch', this, event);
        });

        $('.' + _elementConst['DELETE_SAVED_SEARCH_LINK']).on('click', function (event) {
            _person.process('getDeleteSavedSearchForm', this, event);
        });

        $('.' + _elementConst['SAVE_SEARCH_LINK']).on('click', function () {
            _person.process('getSaveSearchForm');
        });

        $('.' + _elementConst['DELETE_COLLECTION_NAME_LINK']).on('click', function () {
            _person.process('getDeleteCollectionForm', this);
        });

        $('.' + _elementConst['VIEW_REQUISITION']).on('click', function () {
            _person.process('getRequisitionView', this);
        });

        $('.' + _elementConst['URL_REFRESH']).on('click', function () {
            var key = $(this).attr('KEY');
            if (key == 'CLEAR_SEARCH') {
                _person.submitWithoutChangeUrl(key);
            } else {
                _person.submitWithoutChangeUrl('SEARCH', key);
            }
        });

        /**
         * For any button that needs an update for the grid create a key for that element and set it as
         * -> KEY='UPDATE_GRID'
         */
        $("*[KEY='UPDATE_GRID']").on('click', _person.updateGridTrigger);
        $("*[KEY='UPDATE_GRID']").on('keyup', _person.updateGridTrigger);

        /*
         ** Script for showing and hiding the screening questions section.
         */
        $('.jv-toggler').on('click', function () {
            var key = $(this).attr('KEY');
            if ($(this).hasClass('jv-expandIcon')) {
                $(this).removeClass('jv-expandIcon').addClass('jv-collapseIcon');
                $('.' + key).show();
            } else {
                $(this).removeClass('jv-collapseIcon').addClass('jv-expandIcon');
                $('.' + key).hide();
            }
        });


        //      JV.Person['tooltip_counter'] = 0;
        //      //$('#jv-searchCandidateGrid tr td:nth-child(2)').on('mouseover', function(evt){
        //      $('td.jv-candidateName').on('mouseover', function(evt){
        //          var _ceid =  $($($(this).closest('tr').children()[0]).children()[0]).attr('candidate_eid')
        //          var event = $(this).attr('EVENT_ATTACHED');
        //          if( event == 'true'){
        //              return;
        //          }
        //
        //          $(this).attr('EVENT_ATTACHED','true');
        //          //On demand creation of tooltip. Create only when required.
        //          var cloneElement = $('#jv-quickViewTooltip').clone();
        //          cloneElement.attr('id','');
        //          cloneElement.addClass('jv-quickViewTooltip'+'_'+JV.Person['tooltip_counter']);
        //          $('#jv-candidatesGrid').append(cloneElement);
        //
        //          $(this).jvtooltip({
        //              tip: '.jv-quickViewTooltip'+'_'+JV.Person['tooltip_counter'],
        //              position: 'center right',
        //              effect: 'slide',
        //              slideOffset: -6,
        //              predelay: 200,
        //              direction: 'right',
        //                  onShow: function() {
        //                      var me = this.getTrigger()[0];
        //                      // unbing the previous event otherwise it will start firing events for all the bindings.
        //                      //cloneElement.die('click');
        //                      cloneElement.off('click');
        //                      cloneElement.on('click', function(){
        //                          _person.Global.grid.showLoadingState();
        //                          _person.process('quickViewFormOverlay', $(me).children()[0]);
        //                  });
        //              },
        //
        //              onHide: function(){
        //
        //              },
        //
        //              onBeforeShow: function(){
        //              },
        //
        //              onBeforeHide: function(e){
        //              },
        //
        //              events: {
        //                def:     'mouseenter,mouseleave',    // default show/hide events for an element
        //                tooltip: 'mouseenter, mouseleave'
        //              }
        //          });
        //          $(this).trigger('mouseenter');
        //          JV.Person['tooltip_counter']++;
        //      });

    },

    updateLocation: function () {
        if (locAutoComplete && (typeof google === 'object' && typeof google.maps === 'object')) {
            var geo = new google.maps.Geocoder();
            $('#jv-location').autocomplete({
                source: function (request, response) {
                    geo.geocode({
                        'address': request.term
                    }, function (LocObj, status) {
                        response($.map(LocObj, function (item) {
                            return {
                                label: item.formatted_address,
                                value: item.formatted_address,
                                geoObj: item
                            };
                        }));
                    });
                },
                open: function (elem) {
                    var autoBox = $('ul.ui-autocomplete');
                    var pos = $('#' + elem.target.id).offset();
                    $(autoBox).css('z-index', 10000);
                    $(autoBox).css('top', pos.top + $('#' + elem.target.id).outerHeight() + 'px');
                    $(autoBox).css('left', pos.left + 'px');
                    $(autoBox).css('width', ($('#' + elem.target.id).outerWidth() - 2) + 'px');
                },
                close: function () {
                },
                minLength: 3,
                select: function (event, ui) {
                    $('#jv-latitude').val(ui.item.geoObj.geometry.location.lat());
                    $('#jv-longitude').val(ui.item.geoObj.geometry.location.lng());
                }
            });
        }
    },

    updateGridTrigger: function (e) {
        var _person = JV.Person;
        if ((e.type == 'click' && e.currentTarget.type != 'textarea') || (e.which == 13 && $.trim($(e.target).val()) != '')) {
            //Vinoth: Added below line to remove the extra line feeds while submitting the form.
            $(e.target).val($(this).val().replace(/[\n\r]/g, ''));
            var ofccpRef = $('#' + _person.elementConst['OFCCP_RADIO']);
            if (ofccpRef.attr('checked')) {
                _person['mode'] = 'OFCCP';
                //VA: only show the job overlay if the ofccpJobId is not present and not every time.
                if (ofccpRef.val() == -1 || ofccpRef.val() == '') {
                    _person.getOverlayJobs(0);
                    return false;
                }
            } else {
                _person.resetValues();
                _person.resetOverlayValues();
            }
            JV.Modal.hide();
            // just to remove the load of the DOM, in any case if the html is still inside.
            _person.Global.grid.makeCallForGrid();
        }
    },

    resetOverlayValues: function () {
        this['mode'] = null;
        //Vinoth: Commented the below line, since after selecting requisition from job overlay,
        //the name search does not yield results pertaining to the selected filter in requisition dropdown.
        //$('#'+this.elementConst['SELECTED_JOBID']).val('');
        $('#' + this.elementConst['SELECTED_JOB_DESCRIPTION']).val('');
        $('#' + this.elementConst['SELECTED_REQUISITION_ID']).val('');
    },

    toggleSearch: function () {
        var _elementConst = this.elementConst;
        if ($('#' + _elementConst['SEARCH_OPTION_PANEL']).is(':visible')) {
            $('#' + _elementConst['SEARCH_OPTION_PANEL']).removeClass('jv-show').addClass('jv-hide');
            $('#' + _elementConst['SEARCH_OPTION_IMAGE']).removeClass('jv-arrowDown');
        } else {
            $('#' + _elementConst['SEARCH_OPTION_PANEL']).removeClass('jv-hide').addClass('jv-show');
            $('#' + _elementConst['SEARCH_OPTION_IMAGE']).addClass('jv-arrowDown');
        }
    },

    toggleFilters: function (_header, _sibling) {
        var _small = $(_header).hasClass('jv-expIcoSmall') || $(_header).hasClass('jv-collIcoSmall') ? 'Small' : '';
        if (!$(_header).hasClass('jv-expIco' + _small)) {
            $(_header).addClass('jv-expIco' + _small);
            $(_sibling).addClass('jv-hide');
        } else {
            $(_header).removeClass('jv-expIco' + _small);
            $(_sibling).removeClass('jv-hide');
        }
    },

    togglSelection: function (doSelectAll) {
        var _elem = $('input:checkbox[name=checkboxListItems]');
        $('#checkboxAll').attr('checked', !!doSelectAll);
        if (doSelectAll) {
            _elem.attr('checked', 'checked');
            _elem.parent().parent().find('td').css({ 'background': '#EFF9E4' });

            //uncheck the disabled checkboxes and remove the color from them.
            var _uncheckedEle = $("input[name=checkboxListItems][disabled='disabled']");
            _uncheckedEle.attr('checked', '')
            _uncheckedEle.parent().parent().find('td').css({ 'background': '#fff' });

            $('.number').html(_elem.length - _uncheckedEle.length);
        } else {
            $('.number').html(0);
            _elem.attr('checked', false);
            _elem.parent().parent().find('td').css({ 'background': '#FFFFFF' });
        }
    },


    resetValues: function () {
        $('.' + this.elementConst['ACTIONS_COMBO_ELEMENT']).val('0');
        $('.' + this.elementConst['SAVED_SEARCH']).val('0');
    },

    showChangeToVideoWorkflowStateModal: function (stateId, kind, elementRef, stateName) {
        //Hide the change status overlay and bring the Video Screen overlay.
        JV.Modal.hide();
        var sendVideoObject = {};
        sendVideoObject.appIds = this.getSelectedAppIds();

        //If there is only one selection, then we need to grab the name else we dont need.
        if (sendVideoObject.appIds.length === 1) {
            var candidateEId = $('#' + sendVideoObject.appIds[0]).attr('candidate_eid');
            sendVideoObject.name = $('#checkboxList' + candidateEId).find('a.jv-jHireRedirectCandidate').text().trim();
        }
        sendVideoObject.jobEId = JV.Person.getUniqueSelectedApplicationJobIds()[0]
        sendVideoObject.stateId = stateId;
        sendVideoObject.workflowStateKind = kind;

        JV.AngularUtils.broadcast('VIDEO_MODAL_CLICKED_WORKFLOW', sendVideoObject);
        //VA: before you attach the event remove the previous listeners which might be attached.
        JV.AngularUtils.removeAllPreviousListeners('showVideoModalResult');
        //ifSuccess:false ->  the modal request was canceled.
        JV.AngularUtils.attachListeners('showVideoModalResult', function (event, ifSuccess) {
            // can not update the status if the video interview wasn't sent.
            if (!ifSuccess) {
                return;
            }

            //Initialize the change status modal when the operation completes.
            JV.AngularUtils.scope().$broadcast('VIDEO_CLEAR_SCOPE');

            $('#jv-search').data('updateFetch', true);
            // for single click we dont have to show the modal dialog box
            var data = {};
            data.action = 'doChangeStatus';
            if (typeof elementRef !== 'undefined') {
                if (!!elementRef.id) {
                    // Its coming from quick view.
                    data.stateTitle = $(elementRef.elemRef).attr('NEXT_STATE_ID');
                    data.ids = elementRef.id;
                } else {
                    // coming from grid.
                    data.stateTitle = $(elementRef).attr('NEXT_STATE_ID');
                    data.ids = $(elementRef).parentsUntil('tr').parent().find('input:checkbox[name=checkboxListItems]').attr('checked', true).val();
                }
            } else {
                data.stateTitle = stateName;
                data.ids = JV.Person.getSelectedAppIds();
            }
            var args = {};
            args.data = data;
            args.ajaxType = 'changeStatus';
            var _modal = JV.Modal;
            var _person = JV.Person;
            var _util = JV.Util;
            args.success = function (content) {
                if (_person.quickViewChangeStatus) {
                    _person.openQuickViewById(content);
                } else {
                    _modal.hide();
                    _person.Global.grid.makeCallForGrid(function () {
                        _util.showMessage(content);
                    });
                    return false;
                }
            };
            JV.Util.makeAjaxRequest(args);
        });
    },
    process: function (formName, optional, event) {
        var _modal = JV.Modal;
        var _person = JV.Person;
        var _util = JV.Util;

        var jqToAngularTransferObject = {};
        jqToAngularTransferObject.appIds = this.getSelectedAppIds();
        //If there is only one selection, then we need to grab the name else we dont need.
        if (jqToAngularTransferObject.appIds.length === 1) {
            var candidateEId = $('#' + jqToAngularTransferObject.appIds[0]).attr('candidate_eid');
            jqToAngularTransferObject.name = $('#checkboxList' + candidateEId).find('a.jv-jHireRedirectCandidate').text().trim();
        }

        switch (formName) {
            case 'jobForm':
                var evt = window.event || event;
                var _process = false;
                //evt is null in firefox: NV
                if (evt) {
                    if (evt.type == 'keydown' && (evt.which == 13 || evt.keyCode == 13)) {
                        _process = true;
                    } else if (evt.type != 'keydown') {
                        _process = true;
                    }
                }
                if (JV.Person.addReqModalData) {
                    _process = true;
                }
                if (_process) {
                    // Get the values from the overlay.
                    var selectedJobId;
                    if (_HRTECHUI_ENABLED === false || window.disableFlags.selectRequisition) {
                        selectedJobId = $('input:radio[name=jv-jobId]:checked').val();
                    } else {
                        selectedJobId = JV.Person.addReqModalData.reqEId;
                    }

                    if (selectedJobId) {
                        if (this.mode == 'OFCCP') {
                            $('#' + this.elementConst['OFCCP_RADIO']).attr('checked', 'checked');
                            $('#' + this.elementConst['OFCCP_RADIO']).val(selectedJobId);
                            // name for the ofccp job.
                            var name;
                            if (_HRTECHUI_ENABLED === false || window.disableFlags.selectRequisition) {
                                name = $('#jv-jobId' + selectedJobId).attr('title');
                            } else {
                                name = JV.Person.addReqModalData.reqName;
                            }
                            $('#jv-ofccpJobName').val(name);
                        } else {
                            $('#' + this.elementConst['SELECTED_JOBID']).val(selectedJobId);
                        }
                        _modal.hide();
                        //$('#jv-requisitionLoadingStateWrapper').show();
                        _person.Global.grid.makeCallForGrid(function () {
                            _person.process('refreshSearchList', '');
                        });
                        //$('#jv-requisitionLoadingStateWrapper').hide();
                        return true;
                    } else {
                        var errorText = (this.mode == null) ? errorText = JV.Util.Const['JOBSELECT_ERROR'] : errorText = JV.Util.Const['OFCCP_JOBSELECT_ERROR'];
                        $('#' + this.elementConst['ERROR_ELEMENT']).text(errorText);
                        return false;
                    }
                }
                break;
            case 'changeStatusFormOverlay':
                //Disabling the new modal completely as its supposed to go live next release.
                if (_HRTECHUI_ENABLED === false || window.disableFlags.changeStatus) {
                    _modal.render({
                        action: 'getChangeStatusForm',
                        ids: this.getSelectedAppIds()
                    });
                } else {
                    jqToAngularTransferObject.reqId = _person.getUniqueSelectedApplicationJobIds()[0];
                    jqToAngularTransferObject.currentStatus = _person.getUniqueSelectedStatusValue();
                    if (jqToAngularTransferObject.currentStatus.length === 0 && !window.disableFlags.skipWorkflow) {
                        _util.showErrorMessage(this.Const['REQUISITION_SELECT_ERROR']);
                        var addReqLink = '<a href="#" id="jv-selectJobLinkJobRelated">Click to select Requisition </a>';
                        $('#jv-selectionMsg').append(addReqLink);
                        return false;
                    }
                    JV.AngularUtils.broadcast('CHANGE_STATUS_MODAL_CLICKED', jqToAngularTransferObject);
                    JV.AngularUtils.attachListeners('showChangeStatusResult', function (event, ifSuccess) {
                        JV.Person.resetValues();
                        if (ifSuccess) {
                            JV.Util.showMessage(JV.Person.Const['CHANGE_STATUS_SUCCESSFUL']);
                            $('#jv-search').data('updateFetch', true);
                            JV.Person.Global.grid.makeCallForGrid();
                        }
                    });
                }
                return;
                break;
            case 'changeStatusForm':
                // Bulk action.
                //TODO: this is not correct. SUBMIT_TO_HIRING_MANAGER is not a constant state title.
                //admim can customise this state name.
                //Use an html attr to identify the kind of state as SUBMIT_TO_HIRING_MANAGER
                var evt = window.event || event;
                var _process = false;
                if (evt.type == 'keydown' && (evt.which == 13 || evt.keyCode == 13)) {
                    _process = true;
                } else if (evt.type != 'keydown') {
                    _process = true;
                }
                if (_process) {
                    var changeStatusValue = $('#' + this.elementConst['CHANGE_STATUS_ELEMENT']).val();
                    //VA: Are we still using it? As the jhire team has moved most of this functionality in the jv.changeStatus.controller.js file.
                    if (changeStatusValue === 'Video Screen') {
                        // Call the common method which will be called from tooltips also.
                        this.showChangeToVideoWorkflowStateModal();
                    } else if (changeStatusValue === JV.Util.Const['SUBMIT_TO_HIRING_MANAGER']) {
                        _modal.render({
                            action: 'getSubmittedToHiringManagerForm',
                            ids: this.getSelectedAppIds()
                        });
                    } else {
                        this.process('proceedToForm');
                    }
                }
                return true;
                break;
            case 'rejectFormOverlay':
                var nextAppId = $('.jv-quickViewNavigation-next').attr('key');
                if (_HRTECHUI_ENABLED === false || window.disableFlags.rejectCandidate) {
                    var me = this;
                    _modal.render({
                        action: 'getRejectActionForm',
                        ids: me.getSelectedRowIds(optional, $('#jv-quickViewEId').val()).applicationId
                    }, _person.renderEmailTemplateWidgetIframe);
                    return true;
                } else {
                    if (!jqToAngularTransferObject.appIds.length) {
                        jqToAngularTransferObject.appIds = [JV.Person.getSelectedRowIds(optional, $('#jv-quickViewEId').val()).applicationId];
                    }
                    if (JV.Person.getSelectedRowIds().applicationId.length === 0) {
                        jqToAngularTransferObject.name = $('.jv-candidateDetail h3').text();
                    } else {
                        jqToAngularTransferObject.name = JV.Person.getSelectedCandidateName();
                    }
                    jqToAngularTransferObject.reqId = _person.getUniqueSelectedApplicationJobIds()[0];
                    JV.AngularUtils.broadcast('REJECT_CANDIDATES_MODAL_CLICKED', true, jqToAngularTransferObject);
                    JV.AngularUtils.attachListeners('rejectCandidateSuccess', function (event, onlyReset, multiple) {
                        if (onlyReset) {
                            if (JV.Person.quickViewChangeStatus) {
                                JV.Person.process('refreshSearchList');
                                return;
                            }
                            JV.Person.resetValues();
                            return;
                        }
                        if (multiple) {
                            JV.Util.showMessage(JV.Person.Const['REJECT_SUCCESSFUL_MULTIPLE']);
                        } else {
                            JV.Util.showMessage(JV.Person.Const['REJECT_SUCCESSFUL_SINGLE']);
                        }
                        if (JV.Person.quickViewChangeStatus) {
                            if ($('#jv-searchListForm').length === 0) {
                                return;
                            }
                            //refresh the grid
                            var currentPage = parseInt($('#jv-gridPage').val());
                            // After the grid get loaded it always set to 0.
                            $('#jv-page').val(currentPage);
                            $('#jv-search').data('updateFetch', true);
                            JV.Person.Global.grid.makeCallForGrid(function () {
                                //go to next candidate after reject form quickview
                                var eId;
                                if (nextAppId === 'MORE') {
                                    var children = $($('#jv-searchCandidateGrid').children()[1]).children();
                                    var row = children[children.length - 1];
                                    eId = $(row).find("input[type='checkbox']").val();
                                } else {
                                    eId = nextAppId;
                                }
                                JV.Person.makeCallForQuickView(eId);
                            });

                        } else {
                            $('#jv-search').data('updateFetch', true);
                            JV.Person.Global.grid.makeCallForGrid();
                            JV.Person.resetValues();
                        }
                    });
                    JV.AngularUtils.attachListeners('rejectCandidateFailure', function () {
                        JV.Person.resetValues();
                    });
                }
                break;
            case 'rejectForm':
                //TODO: add rejection parameters
                var evt = window.event || event;
                var _process = false;
                if (evt.type == 'keydown' && (evt.which == 13 || evt.keyCode == 13)) {
                    _process = true;
                } else if (evt.type != 'keydown') {
                    _process = true;
                }
                if (_process) {
                    $('#jv-search').data('updateFetch', true);
                    this.submitForm(formName, function (content) {
                        if (_person.quickViewChangeStatus) {
                            _person.openQuickViewById(content);
                        } else {
                            _modal.hide();
                            _person.Global.grid.makeCallForGrid(function () {
                                _util.showMessage(content);
                            });
                            return false;
                        }
                    });
                }
                break;
            case 'deleteFormOverlay':
                //call new modal here
                var data = {
                    appIds: JV.Person.getSelectedAppIds()
                };
                if (data.appIds.length === 1) {
                    data.name = JV.Person.getSelectedCandidateName();
                }
                if (_HRTECHUI_ENABLED === false || window.disableFlags.deleteCandidate) {
                    _modal.render({
                        action: 'getDeleteActionForm',
                        ids: this.getSelectedAppIds()
                    });
                } else {
                    JV.AngularUtils.broadcast('DELETE_MODAL_CLICKED', data);
                }
                return;
            case 'deleteForm':
                //_modal.initialize( );
                $('#jv-search').data('updateFetch', true);
                this.submitForm(formName, function (content) {
                    _modal.hide();
                    _person.Global.grid.makeCallForGrid(function () {
                        _util.showMessage(content);
                    });
                });
                return true;
            case 'addToCollectionFormOverlay':
                if (_HRTECHUI_ENABLED === false || window.disableFlags.addToCollection) {
                    _modal.render({
                        action: 'getAddToCollectionForm',
                        ids: this.getSelectedAppIds()
                    });
                } else {
                    JV.AngularUtils.broadcast('ADD_TO_COLLECTION_MODAL_CLICKED', jqToAngularTransferObject);
                    JV.AngularUtils.attachListeners('showAddToCollectionResult', function (event, ifSuccess, collectionName) {
                        //This is called when the Add to Collection modal is dismissed
                        if (ifSuccess) {
                            //Need to discuss what to display
                            JV.Util.showMessage(JV.Person.Const['ADD_TO_COLLECTION_SUCCESSFUL']);
                        }

                        JV.Person.resetValues();
                        //Since its just adding collection to the users, we dont need to refresh the grid.
                    });
                }
                return;
            case 'addToCollectionForm':
                var collectionName = $('#' + _person.elementConst['SELECT_COLLECTION']).val();
                var newCollection = 'false';
                if ($('#' + _person.elementConst['ADD_COLLECTION']).hasClass('jv-show')) {
                    collectionName = $('#' + _person.elementConst['SELECT_COLLECTION_INPUT']).val();
                    newCollection = 'true';
                }
                //Set the attributes
                $('#jv-collectionName').val(collectionName);
                $('#jv-appIds').val(this.getSelectedAppIds());
                if ($.trim(collectionName) == '' || $.trim(collectionName) == 'Select Collection') {
                    $('#' + this.elementConst['MESSAGE_ERROR']).css('display', '').html(_person.Const['COLLECTION_NAME_REQUIRED']);
                    return false;
                }
                this.submitForm(formName, function (content) {
                    _modal.hide();
                    // refresh only the left filters.
                    _person.process('refreshSearchList');
                    _util.showMessage(content);
                    _person.resetAfterActionUpdates();
                });
                return true;
                break;
            //Vinoth: Gets the remove from collection overlay.
            case 'getRemoveFromCollectionFormOverlay':
                _modal.render({
                    action: 'getRemoveFromCollectionForm',
                    ids: this.getSelectedAppIds(),
                    collectionId: $('#jv-savedCollections').val()
                });
                return;
                break;
            //Vinoth: Sends the selected ids to remove from collection action, gets the confirmation
            //message and refreshes the grid.
            case 'removeFromCollectionForm':
                $('#jv-appIds').val(this.getSelectedAppIds());
                this.submitForm(formName, function (content) {
                    _modal.hide();
                    _person.Global.grid.makeCallForGrid(function () {
                        _util.showMessage(content);
                    });
                });
                return true;
                break;
            case 'sendOfferForm':
                _modal.render({
                    action: 'getSendOfferForm',
                    ids: this.getSelectedAppIds()
                });
                return;
                break;
            case 'proceedToForm':
                if (_HRTECHUI_ENABLED === false || window.disableFlags.changeStatus) {
                    //Vinoth: Added for DB optimized querying. Since set as 'TRUE', the master DB
                    //will be queried on changing the status to load the grid.
                    $('#jv-search').data('updateFetch', true);
                    // for single click we dont have to show the modal dialog box
                    var data = {};
                    data.action = 'doChangeStatus';
                    if (!!optional) {
                        if (!!optional.id) {
                            // Its coming from quick view.
                            data.stateTitle = $(optional.elemRef).attr('NEXT_STATE_ID');
                            data.ids = optional.id;
                        } else {
                            // coming from grid.
                            data.stateTitle = $(optional).attr('NEXT_STATE_ID');
                            data.ids = $(optional).parentsUntil('tr').parent().find('input:checkbox[name=checkboxListItems]').attr('checked', true).val();
                        }
                    } else {
                        data.stateTitle = $('#' + this.elementConst['CHANGE_STATUS_ELEMENT']).val();
                        data.ids = this.getSelectedAppIds();
                    }
                    var args = {};
                    args.data = data;
                    args.ajaxType = formName;
                    args.success = function (content) {
                        if (_person.quickViewChangeStatus) {
                            _person.openQuickViewById(content);
                        } else {
                            _modal.hide();
                            _person.Global.grid.makeCallForGrid(function () {
                                _util.showMessage(content);
                            });
                            return false;
                        }
                    };
                    JV.Util.makeAjaxRequest(args);
                    return;
                } else {
                    //call new change status endpoint
                    var applicationIds;
                    var changeStatusObject = {
                        appIds: [],
                        name: ''
                    };
                    if (JV.Person.getSelectedAppIds().length) {
                        applicationIds = [JV.Person.getSelectedAppIds()[0]];
                    } else {
                        applicationIds = [JV.Person.getSelectedRowIds(optional, $('#jv-quickViewEId').val()).applicationId];
                    }
                    if (optional.elemRef) {
                        //coming from quickview
                        changeStatusObject.name = $(optional.elemRef).attr('title');
                    } else {
                        //clicking from status column
                        changeStatusObject.name = $(optional).attr('title');
                    }
                    changeStatusObject.appIds = applicationIds;
                    changeStatusObject.skipModalView = true;

                    JV.AngularUtils.attachListeners('showChangeStatusResult', function (event, ifSuccess, appId) {
                        if ($('#jv-searchListForm').length === 0) {
                            JV.Person.makeCallForQuickViewOverlayForApplication(appId);
                            return;
                        }
                        JV.Person.resetValues();
                        if (ifSuccess) {
                            JV.Util.showMessage(JV.Person.Const['CHANGE_STATUS_SUCCESSFUL']);
                            $('#jv-search').data('updateFetch', true);
                            JV.Person.Global.grid.makeCallForGrid();
                        }
                    });
                    JV.AngularUtils.broadcast('CHANGE_STATUS_MODAL_CLICKED', changeStatusObject);
                }
                break;
            case 'submitToHiringManagerForm':
                //Validate the Mandatory fields
                var subject = $('#' + this.elementConst['MESSAGE_SUBJECT']).val();
                if ($.trim(subject) == '') {
                    $('#' + this.elementConst['MESSAGE_ERROR']).css('display', '').html(_person.Const['SUBJECT_REQUIRED']);
                    return false;
                }
                this.submitForm(formName, function (content) {
                    if (_person.quickViewChangeStatus) {
                        _person.openQuickViewById(content);
                    } else {
                        _modal.hide();
                        $('#jv-search').data('updateFetch', true);
                        _person.Global.grid.makeCallForGrid(function () {
                            _util.showMessage(content);
                        });
                        return false;
                    }
                });
                return false;
                break;
            case 'getSubmitToHiringManagerForm':
                if (_HRTECHUI_ENABLED === false || window.disableFlags.changeStatus) {
                    _modal.render({
                        action: 'getSubmittedToHiringManagerForm',
                        ids: this.getSelectedRowIds(optional, $('#jv-quickViewEId').val()).applicationId
                    });
                }
                else {
                    if (JV.Person.quickViewChangeStatus) {
                        JV.Modal.hide();
                    }

                    var submitToHiringManagerObject = {};
                    var applicationIds;
                    if (JV.Person.getSelectedAppIds().length) {
                        applicationIds = [JV.Person.getSelectedAppIds()[0]];
                    } else {
                        applicationIds = [JV.Person.getSelectedRowIds(optional, $('#jv-quickViewEId').val()).applicationId];
                    }
                    submitToHiringManagerObject.appIds = applicationIds;
                    if (JV.Person.getSelectedRowIds().applicationId.length === 0) {
                        submitToHiringManagerObject.name = ' 1 Candidate';
                    } else {
                        submitToHiringManagerObject.name = JV.Person.getSelectedCandidateName();
                    }
                    if (optional.elemRef) {
                        //coming from quickview
                        submitToHiringManagerObject.stateId = $(optional.elemRef).attr('candidatestateid');
                        submitToHiringManagerObject.jobEId = $(optional.elemRef).attr('jobId');
                    } else {
                        //clicking from status column
                        submitToHiringManagerObject.stateId = $(optional).attr('candidatestateid');
                        submitToHiringManagerObject.jobEId = $(optional).attr('jobId');
                    }

                    JV.AngularUtils.broadcast('SUBMIT_HM_MODAL_CLICKED', submitToHiringManagerObject);
                    return false;
                }
                break;
            case 'getSendVideoModalFormOverlay':
                // Called for adhoc video interviews.
                var sendVideoObject = {};
                sendVideoObject.appIds = this.getSelectedAppIds();
                //If there is only one selection, then we need to grab the name else we dont need.
                if (sendVideoObject.appIds.length === 1) {
                    var candidateEId = $('#' + sendVideoObject.appIds[0]).attr('candidate_eid');
                    sendVideoObject.name = $('#checkboxList' + candidateEId).find('a.jv-jHireRedirectCandidate').text().trim();
                }

                JV.AngularUtils.broadcast('VIDEO_MODAL_CLICKED', sendVideoObject);
                JV.AngularUtils.removeAllPreviousListeners('showVideoModalResult');
                JV.AngularUtils.attachListeners('showVideoModalResult', function (event, ifSuccess) {
                    //This is called when the video modal is dismissed
                    if (ifSuccess) {
                        _util.showMessage(JV.Person.Const['INVITE_SENT']);
                    }

                    JV.Person.resetValues();
                    $('#jv-search').data('updateFetch', true);
                    JV.Person.Global.grid.makeCallForGrid();
                });
                break;
            case 'sendMessageFormOverlay':
                if (_HRTECHUI_ENABLED === false || window.disableFlags.sendMessage) {
                    var _ids = '';
                    var me = this;
                    var apIds = me.getSelectedAppIds();
                    _modal.render({
                        action: 'getSendMessageForm',
                        ids: me.getSelectedAppIds()
                    }, _person.renderEmailTemplateWidgetIframeforSM);
                    return true;
                } else {
                    JV.AngularUtils.broadcast('SEND_MSG_MODAL_CLICKED');
                }
                break;
            case 'sendMessageForm':
                var evt = window.event || event;
                var _process = false;
                if (evt.type == 'keydown' && (evt.which == 13 || evt.keyCode == 13)) {
                    _process = true;
                } else if (evt.type != 'keydown') {
                    _process = true;
                }
                if (_process) {
                    //Validate the Mandatory fields
                    var subject = $('#' + this.elementConst['MESSAGE_SUBJECT']).val();
                    var message = $('#' + this.elementConst['MESSAGE_CONTENT']).val();

                    if ($.trim(subject) == '') {
                        $('#' + this.elementConst['MESSAGE_ERROR']).css('display', '').html(_person.Const['SUBJECT_REQUIRED']);
                        return false;
                    }
                    else if ($.trim(message) == '') {
                        $('#' + this.elementConst['MESSAGE_ERROR']).css('display', '').html(_person.Const['MESSAGE_REQUIRED']);
                        return false;
                    }

                    this.submitForm(formName, function (content) {
                        _modal.hide();
                        _util.showMessage(content);
                        _person.resetAfterActionUpdates();
                    });
                }
                return false;
                break;
            // TODO: The backend is not ready. so this is just the code for now.
            case 'quickViewFormOverlay':
                var navDetails = this.getQuickViewNavigationDetails(optional);
                //Vinoth: Added 'selectedTab' attribute to make the selected tabs sticky in quick view overlay.
                var _quickViewTab = $('#jv-quickViewSelectedTab').val();
                _quickViewTab = typeof (_quickViewTab != 'undefined' || _quickViewTab != '') ? _quickViewTab : 'jv-dialogSummary';
                //Vinoth: Added the logic to unbold the candidates after it's been read.
                //After we view a new candidate using the wuick view we mark the candidate as read but since we dont refresh the grid the candidate name is bold and looks like its unread.
                $(optional).parent().parent('tr').removeClass('unread');
                var _reqObj = {
                    action: 'getQuickViewForm',
                    ids: this.getSelectedRowIds(optional, $('#jv-quickViewEId').val()).applicationId,
                    eids: $($(optional).closest('tr').children()[0]).children().attr('candidate_eid'),
                    next: navDetails.next,
                    previous: navDetails.previous,
                    page: navDetails.page,
                    totalPages: navDetails.totalPages,
                    selectedTab: _quickViewTab
                };
                _reqObj.request = $.toJSON(_reqObj);
                _modal.render(_reqObj, null, $('#jv-modalDialog').css('display') == 'none');

                // bind the click event on the reject later icon after the dialog finishes loading
                $(document).off('click.reject').on('click.reject', '#rejectLaterIcon', function (e) {
                    $('#rejectLaterTooltip').toggle();
                });
                return true;
                break;
            /*
             * VA: Where are we using it?
             * Vinoth: Used when quick views' 'View Candidate' button is clicked.
             */
            case 'quickViewForm':
                var _appEID = $('#' + this.elementConst['QUICK_VIEW_EID']).val();
                var _jobId = $('#' + this.elementConst['QUICK_VIEW_SCRAMBLED_JOBID']).val();
                if (typeof ($('select[name=jobIds]').val()) != 'undefined') {
                    $('input[name=jobIds]').val($('select[name=jobIds]').val());
                }
                var args = {};
                args.data = {
                    action: 'getCandidateDetailsView',
                    page: $('#jv-gridPage').val(),
                    ids: _appEID
                };
                // specify the type of request you are sending.
                args.ajaxType = 'redirectCandidateFromQuickView';
                args.success = function (resultList) {
                    if (resultList && typeof resultList == 'string') {
                        $('#jv-postData').val(resultList);
                        if ($('#q').val() != JV.Person.elementConst['ENTER_SEARCH_TEXT']) {
                            $('#jv-viewCandidateForm').append($('<input/>', {
                                type: 'hidden',
                                id: 'jv-keywords',
                                name: 'keywords',
                                value: $('#q').val()
                            }));
                        }
                        $('#jv-viewCandidateForm').submit();
                    } else {
                        // Notify the backend that the call failed for some reason.
                    }
                };
                JV.Util.makeAjaxRequest(args);
                break;
            /**
             * GRE: Used for accessing the requisition for scheduler role, on click of job link*/
            case 'getRequisitionView':
                var schedulerJobId = $(optional).attr('SCHEDULER_JOBID');
                _modal.render({
                    action: 'getRequisitionView',
                    jobIds: schedulerJobId

                });

                break;

            case 'getSaveSearchForm':
                _modal.render({
                    action: 'getSaveSearchForm'
                });
                break;
            case 'getRenameSavedSearchForm':
                var evt = window.event || event;
                var _process = false;
                if (evt.type == 'keydown' && (evt.which == 13 || evt.keyCode == 13)) {
                    _process = true;
                } else if (evt.type != 'keydown') {
                    _process = true;
                }
                if (_process) {
                    //Vinoth: Modified for inline saving of renamed save search.
                    $(optional).parent().prev().prev().children().attr('checked', 'checked');
                    searchNameRow = $(optional).parent().parent();
                    searchNameSelectedRow = searchNameRow.find('div.jv-colDescription');
                    renameLink = searchNameRow.find('a.' + this.elementConst['RENAME_SAVED_SEARCH_LINK']);
                    searchNameSelectedRow.find('.' + this.elementConst['SAVED_SEARCH_NAME_ELEMENT']).hide();
                    searchNameSelectedRow.append(
                        $('<input/>', {
                            'name': 'searchName',
                            'id': 'jv-modalSaveSearchName',
                            'type': 'text',
                            'value': searchNameSelectedRow.children().text(),
                            'size': 60
                        }));
                    var selectedSearch = $(optional).parent().prev().find('a.' + this.elementConst['SAVED_SEARCH_NAME_ELEMENT']).text();
                    searchNameRow.find('div.jv-colAction:eq(0)')
                        .append($('<a/>', { 'href': '#$', 'class': 'jv-renameSaveLink', 'text': i18n['JV_APPLICANT_SAVE'] }).click(function () {
                            if (searchNameSelectedRow.find('input[name=searchName]').val() == selectedSearch) {
                                return false;
                            }
                        }))
                        .append(' | ')
                        .append($('<a/>',
                            { 'href': '#$', 'class': 'jv-cancelLink', 'text': i18n['JV_APPLICANT_CANCEL'] })
                            .click(function () {
                                searchNameSelectedRow.find('.' + _person.elementConst['SAVED_SEARCH_NAME_ELEMENT']).show();
                                anchorRename = renameLink;
                                $('#jv-modalSaveSearchName').remove();
                                searchNameRow.find('div.jv-colAction:eq(0)').html('').append(renameLink.text(i18n['JV_APPLICANT_RENAME']).show());
                                $(optional).parent().prev().prev().children().attr('checked', '');
                            }));
                    renameLink.hide();
                }
                break;
            case 'doSaveSearch':
            case 'doRenameSavedSearch':
                var evt = window.event || event;
                var _process = false;
                if (evt.type == 'keydown' && (evt.which == 13 || evt.keyCode == 13)) {
                    _process = true;
                } else if (evt.type != 'keydown') {
                    _process = true;
                }
                if (_process) {
                    // change the variables for the form.
                    $('#action').val(formName);
                    // get the searchId and the searchName from optional if available and set them if necessary.
                    //$('#searchId').val(optional);
                    $('#searchId').val($(optional).parent().prev().prev().children().val());
                    $('#searchName').val($('#jv-modalSaveSearchName').val());
                    $('#jv-SearchError').text(i18n['JV_APPLICANT_SAVING_']);
                    var searchName = $('#searchName').val();
                    if (($('#jv-modalSaveSearchName').val()).search(/[^a-zA-Z0-9 ]/g) != -1) {
                        $('#jv-SearchError').html(_person.Const['NAME_CONSTRAINTS']);
                        $('#jv-SearchError').show();
                        return false;
                    }
                    else if ($.trim(($('#jv-modalSaveSearchName').val())) == '') {
                        $('#jv-SearchError').html(i18n['JV_APPLICANT_NAME_IS_REQUIRED'])
                        $('#jv-SearchError').show();
                        return false;
                    }
                    this.submitForm('jv-searchListForm', function (content) {
                        if (formName == 'doSaveSearch') {
                            if (typeof content == 'string') {
                                $('#jv-SearchError').text('').text(content).fadeOut(1500);
                            }
                            setTimeout(function () {
                                // close the modal dialog box.
                                _modal.hide();
                                _person.process('refreshSearchList');
                                //TODO: reload the search-list porition of the candidates page.
                            },
                                2500);
                        } else {
                            // Check if it is bad request
                            $('#jv-SearchError').text(searchName + _person.Const['SEARCH_SUCCESS']).fadeOut(5000);
                            if (typeof (content) == 'string') {
                                searchNameRow = $(optional).parent().parent();
                                searchNameSelectedRow = searchNameRow.find('div.jv-colDescription');
                                renameLink = searchNameRow.find('a.' + JV.Person.elementConst['RENAME_SAVED_SEARCH_LINK']);

                                var changedSearchValue = searchNameSelectedRow.find('#jv-modalSaveSearchName').val();
                                searchNameSelectedRow.find('.' + JV.Person.elementConst['SAVED_SEARCH_NAME_ELEMENT']).text(changedSearchValue).show();
                                anchorRename = renameLink;
                                $('#jv-modalSaveSearchName').remove();
                                searchNameRow.find('div.jv-colAction:eq(0)').html('').append(renameLink.text(i18n['JV_APPLICANT_RENAME']).show());
                                searchNameRow.find('div.jv-colRadioAction').children().attr('checked', '');
                            }
                        }
                    }, function (state) {
                        if (state.status == 400) {
                            $('#jv-SearchError').text(_person.Const['SEARCH_NAME_EXITS']);
                        }
                    });
                }
                return false;
                break;
            case 'getDeleteSavedSearchForm':
                var evt = window.event || event;
                var _process = false;
                if (evt.type == 'keydown' && (evt.which == 13 || evt.keyCode == 13)) {
                    _process = true;
                } else if (evt.type != 'keydown') {
                    _process = true;
                }
                if (_process) {
                    $(optional).parent().prev().prev().prev().children().attr('checked', 'checked');
                    _person.process('doDeleteSavedSearch', optional);
                    return false;
                }
                break;
            case 'doDeleteSavedSearch':
                $('#action').val('doDeleteSavedSearch');
                searchNameRow = $(optional).parent().parent();
                searchNameSelectedText = searchNameRow.find('div.jv-colDescription').text();
                searchNameSelectedValue = searchNameRow.find('div.jv-colRadioAction').children().val();
                $('#searchId').val(searchNameSelectedValue);
                $('#searchName').val(searchNameSelectedText);
                $('#jv-SearchError').text(i18n['JV_APPLICANT_DELETING_']);
                this.submitForm('jv-searchListForm', function (content) {
                    if (typeof (content) == 'string') {
                        $('#jv-SearchError').text(_person.Const['DELETE_SUCCESSFUL']).fadeOut(5000);
                        searchNameRow.remove();
                        //_person.process('refreshSearchList', '');
                        _person.submitWithoutChangeUrl('CLEAR_SEARCH');
                    }
                });
                return false;
                break;
            case 'refreshSearchList':
                if ($('#jv-searchListForm').length === 0) {
                    return;
                }
                $('#action').val('getFilterView');
                //$('#refreshSearchList').val('refreshSearchList');
                // TODO: if we delete the current search what should happen?
                this.Global.grid.showLoadingState();
                this.submitForm('jv-searchListForm', function (content) {
                    _modal.hide();
                    $('#jv-searchListForm').replaceWith(content);
                    $('#refreshSearchList').val('');
                });
                break;
            case 'savedSearchListForm':
                //Vinoth: Since search name is required to get populated in search summary, extracting it from UI and
                //passing it to BE.
                //Reviewer Name: Hari, Reviewed on: 3/13/2011
                var selectedSearch = $('input:radio[name=jv-savedSearchId]:checked').val();
                var selectedSearchName = $.trim($('input:radio[name=jv-savedSearchId]:checked').parent().next().text());
                if (selectedSearch) {
                    _person.Global.grid.showLoadingState();
                    _person.submitWithoutChangeUrl('SEARCH', selectedSearch, selectedSearchName);
                } else {
                    $('#jv-SearchError').text(_person.Const['SEARCH_NAME_SELECT_ERROR']);
                }
                return false;
                break;
            case 'savedCollectionListForm':
                var evt = window.event || event;
                var _process = false;
                if (evt.type == 'keydown' && (evt.which == 13 || evt.keyCode == 13)) {
                    _process = true;
                } else if (evt.type != 'keydown') {
                    _process = true;
                }
                if (_process) {
                    var selectedCollectionId = $('input:radio[name=jv-savedCollectionId]:checked').val();
                    var selectedCollectionName = $('input:radio[name=jv-savedCollectionId]:checked').parent().next().children().text();
                    $('#jv-savedCollections').val(selectedCollectionId);
                    //Vinoth: Added collection name field to capture the name that needs to be passed on to BE.
                    $('#jv-savedCollectionName').val(selectedCollectionName);
                    if (selectedCollectionId) {
                        _person.Global.grid.makeCallForGrid();
                    } else {
                        $('#jv-SearchError').text(_person.Const['COLLECTION_NAME_SELECT_ERROR']).fadeOut(5000);
                    }
                }
                return false;
                break;
            case 'getDeleteCollectionForm':
                $('#action').val('doDeleteCollection');
                $(optional).parent().prev().prev().children().attr('checked', 'checked');
                collectionNameRow = $(optional).parent().parent();
                collectionNameSelectedText = collectionNameRow.find('div.jv-colDescription').text();
                collectionNameSelectedValue = collectionNameRow.find('div.jv-colRadioAction').children().val();
                $('#jv-savedCollections').val(collectionNameSelectedValue);
                $('#jv-searchListForm').append($('<input/>', {
                    'type': 'hidden',
                    'id': 'collectionName',
                    'name': 'collectionName',
                    'value': collectionNameSelectedText
                }));
                $('#jv-SearchError').text(i18n['JV_APPLICANT_DELETING_']).fadeIn(3000);
                this.submitForm('jv-searchListForm', function (content) {
                    if (typeof (content) == 'string') {
                        $('#jv-SearchError').text(_person.Const['DELETE_SUCCESSFUL']).fadeOut(3000);
                        collectionNameRow.remove();
                        //JV.Person.process('refreshSearchList', '');
                        _person.submitWithoutChangeUrl('CLEAR_SEARCH');
                        //$('#jv-savedCollections').val('');
                        //$('#collectionName').val('');
                        $('#action').val('initialize');
                        //_person.Global.grid.makeCallForGrid(function(){
                        //  $('.jv-selectCollections').trigger('click');
                        //});
                    }
                });
                return false;
                break;
            case 'moveCandidateFormOverlay':
                var moveCandidateModalObject = {
                    appIds: JV.Person.getSelectedAppIds()
                };
                JV.AngularUtils.broadcast('MOVE_MODAL_CLICKED', moveCandidateModalObject);
                break;

            case 'sendNoteFormOverlay':
                JV.AngularUtils.broadcast('SEND_NOTE_CLICKED', jqToAngularTransferObject);
                JV.AngularUtils.attachListeners('showSendNoteResult', function (event, ifSuccess) {
                    //This is called when the Add to Collection modal is dismissed
                    JV.Person.resetValues();
                    if (ifSuccess) {
                        JV.Util.showMessage(JV.Person.Const['NOTES_ADDED_SUCCESSFULLY']);
                        $('#jv-search').data('updateFetch', true);
                        JV.Person.Global.grid.makeCallForGrid();
                    }
                });

                break;

            case 'addCandidateToReqFormOverlay':
                //show new modal
                var data = {
                    appIds: JV.Person.getSelectedAppIds()
                };
                if (data.appIds.length === 1) {
                    data.name = JV.Person.getSelectedCandidateName();
                }
                JV.AngularUtils.broadcast('ADD_TO_REQ_MODAL_CLICKED', data);
                break;

            default:

        }
    },

    //Vinoth: Added to reset the selected elements and action dropdowns after the action is performed.
    resetAfterActionUpdates: function () {
        $('input:checkbox[name=checkboxListItems]').attr('checked', false);
        $('#' + JV.Person.elementConst['CLEARALL_CHECKBOX']).trigger('click');
        JV.Person.resetValues();
    },

    //Gets the current/next/previous element id and returns the id to the caller function.
    getQuickViewId: function () {
        var id;
        var selectedId = $('#jv-search').data('values').selectedId;
        //If current id exists in the grid.
        if ($("input:checkbox[value='" + selectedId + "']").length == 1) {
            id = selectedId;
        }
        //If current id does not exist in grid and next record id will be displayed in quickview.
        if ($("input:checkbox[value='" + selectedId + "']").length == 0 && $('#jv-search').data('values').currentId == 'true') {
            id = $('#jv-search').data('values').id;
        }
        if ($("input:checkbox[value='" + selectedId + "']").length == 0 && $('#jv-search').data('values').currentId == 'false') {
            //If current id does not exist in grid, takes the last record in page and retrieve it's id.
            if ($('#jv-search').data('values').id == 'MORE') {
                id = $('#jv-searchCandidateGrid tr:last').parentsUntil('tr').parent().find('input:checkbox').val();
            }
            //Failsafe condition, incase if grid refresh not done. Wait for a second and last record of the grid is fetched and id is retrieved.
            if (typeof (id) == 'undefined' || id == 'on' || !isNaN(id)) {
                setTimeout(function () {
                    id = ($('#jv-searchCandidateGrid tr:last').find('input:checkbox').val());
                }, 1000);
            }
        }
        return id;
    },

    /**
     *** Finds the id and sets the id for which quickview should be opened.
     *** @param navDetails - Object which holds the next, previous, page and totalPages values.
     *** @param quickViewId - Current quick view id.
     **/
    findIdByPosition: function (navDetails, quickViewId) {
        var next = navDetails.next;
        var previous = navDetails.previous;
        var page = navDetails.page;
        var nextLength = $("input:checkbox[value='" + next + "']").length;
        var prevLength = $("input:checkbox[value='" + previous + "']").length;
        //Condition checks for fetching the id.
        if (nextLength > 0) {
            $('#jv-search').data('values', { 'id': next, 'currentId': 'true', 'page': page, 'selectedId': quickViewId });
        } else if (prevLength > 0 && (next == -1 || next != 'MORE')) {
            $('#jv-search').data('values', { 'id': previous, 'currentId': 'true', 'page': page, 'selectedId': quickViewId });
        } else if (next == -1 && previous == 'MORE') {
            $('#jv-search').data('values', { 'id': 'MORE', 'currentId': 'false', 'page': parseInt((page - 1), 10), 'selectedId': quickViewId });
        } else if (next == -1 && previous == -1) {
            $('#jv-search').data('values', { 'id': -1, 'currentId': 'false', 'page': page, 'selectedId': quickViewId });
        } else if (next == 'MORE' && nextLength == 0) {
            $('#jv-search').data('values', { 'id': 'MORE', 'currentId': 'false', 'page': page, 'selectedId': quickViewId });
        }
    },

    openQuickViewById: function (content) {
        var _person = JV.Person;
        //Retains/updates the page number element with respect to the current element.
        if ($('#' + JV.Person.elementConst['PAGE_ELEMENT']).length) {
            $('#' + JV.Person.elementConst['PAGE_ELEMENT']).val($('#jv-search').data('values').page);
            _person.Global.grid.makeCallForGrid(function () {
                var id = _person.getQuickViewId();
                //Checks whether the response has come from webservice call and makes call for quickview overlay.
                if (typeof (content) == 'string' && $("input:checkbox[value='" + id + "']").length > 0) {
                    _person.makeCallForQuickView(id);
                    //Resets the page number to '0', since on change of filter the first page should be shown always.
                    $('#' + JV.Person.elementConst['PAGE_ELEMENT']).val(0);
                }
                _person.quickViewChangeStatus = false;
                return true;
            });
        }

    },

    // Returns the info quickView Navigation.
    getQuickViewNavigationDetails: function (elementRef) {
        var parent = $(elementRef).parentsUntil('tr').parent();
        var prev = $(parent).prev();
        var next = $(parent).next();
        prev = ($(prev).length > 0) ? $(prev).find('input:checkbox[name=checkboxListItems]').val() : false;
        next = ($(next).length > 0) ? $(next).find('input:checkbox[name=checkboxListItems]').val() : false;

        if (!prev) {
            prev = (parseInt($('#jv-gridPage').val()) == 0) ? '-1' : 'MORE';
        }
        if (!next) {
            next = (parseInt($('#jv-gridPage').val()) == parseInt($('#jv-gridTotalPages').val()) - 1) ? '-1' : 'MORE';
        }

        return {
            'next': next,
            'previous': prev,
            'page': $('#jv-gridPage').val(),
            'totalPages': $('#jv-gridTotalPages').val()
        };
    },

    /**
     *
     * @param {Object} String
     * @param {Object} Function
     */
    submitForm: function (formId, callback, errorCallback) {
        if (!errorCallback) {
            errorCallback = function () { };
        }
        if (!!_HRTECHUI_ENABLED && _HRTECHUI_ENABLED == true && $("#" + formId + "[name='enableHRUI']").length == 0) {
            $('#' + formId).append("<input type='hidden' value='true' name='enableHRUI' />");
        }

        $('#' + formId).on('submit', function () {
            JV.Person.removeFadedText();
            // optional is needed so that we can use it to submit the forms for refreshing the pages.
            //TODO: Make a loading state for the modal dialog boxes.
            dataString = $(this).serialize();
            JV.Util.makeAjaxRequest({
                type: 'POST',
                url: JV.AJAX_URL,
                data: dataString,
                ajaxType: formId,
                success: function (data) {
                    if (formId == 'rejectForm' || formId == 'doDeleteSavedSearch') {
                        JV.Modal.hide();
                    }
                    callback(data);
                },
                error: function (data) {
                    if (formId == 'rejectForm' || formId == 'doDeleteSavedSearch') {
                        JV.Modal.hide();
                    }
                    errorCallback(data);
                }
            });

            if (formId == 'rejectForm' || formId == 'doDeleteSavedSearch') {
                JV.Person.Global.grid.showProcessingState();
            }
            return false;
        });
        $('#' + formId).submit();
        JV.Person.addFadedText();
        // Otherwise it will keep firing all the bounded submit events again and again.
        $('#' + formId).off('submit');
    },


    submitWithoutChangeUrl: function (type, key, text) {

        var name = '';
        var value = '';
        switch (type) {
            case 'CLEAR_SEARCH':
                name = 'clear';
                value = 'search';
                break;
            case 'SEARCH':
                // only values with 2 are coming here so no worries to take care of other values.
                name = 'searchId';
                value = key;
                break;
        }
        //Reviewer Name: Hari, Reviewed on: 3/13/2011
        //Vinoth: Saved search name is captured from overlay and dropdown as well for refreshing the grid with appropriate values.
        var selectedTextFromDropdown = $('#' + JV.Person.elementConst['SAVED_SEARCH'] + ' option:selected').text();
        var selectedTextFromOverlay = text;
        var selectedText = (typeof (selectedTextFromOverlay) != 'undefined') ? selectedTextFromOverlay : selectedTextFromDropdown;
        if (selectedText != 'Saved Searches' || selectedText != '') {
            $('#jv-savedSearchQueryParam').attr('name', 'searchName');
            $('#jv-savedSearchQueryParam').attr('value', selectedText);
        }

        // set the values for the form and then submit the form.
        $('#jv-queryParam').attr('name', name);
        $('#jv-queryParam').attr('value', value);

        if ($('#jv-modalDialog div.jv-rowDiv').length === 0) {
            $('#jv-changeUrlForm input#jv-updateFetch').val(true);
            $('#jv-changeUrlForm').submit();
        }
    },

    getOverlayJobs: function (page) {
        var _modal = JV.Modal;
        var jobStateValue = $('#' + this.elementConst['SEARCH_REQUISITION_ELEMENT']).val();
        var query = $('#' + this.elementConst['SEARCH_TEXT_ELEMENT']).val();
        _modal.render({
            action: 'getJobs',
            jobStateValue: jobStateValue,
            q: query,
            page: page,
            sortBy: $('#' + this.elementConst['OVERLAY_SORTBY']).val(),
            //Vinoth: Sending overlay mode to BE, to classify between jobs overlay and OFCCP job overlay while navigating thru pages.
            overlayMode: JV.Person['mode']
        });
    },

    //Greeshma: Get Collections overlay.
    getCollectionsOverlay: function (page) {
        var _modal = JV.Modal;
        var query = $('#jv-collectionsText').val();
        _modal.render({
            action: 'getCollectionsView',
            page: page,
            sortBy: $('#' + this.elementConst['OVERLAY_SORTBY']).val()
        });
    },

    renderEmailTemplateWidgetIframe: function (content) {
        var me = this;
        var _modal = JV.Modal;
        //$($(content).find('#templateActualContainer').html(JV.Person.emailWidgetData));
        $('#' + _modal.modalElement).jqmHide();
        $('#' + _modal.modalElement).html(content);

        var apIds = []; //JV.Person.getSelectedAppIds();
        $('.jv-appId').each(function (index) {
            apIds[index] = $(this).val();
        });
        //checking for candidate mail id
        if ((apIds.length > 1) || (apIds.length == 1 && JV.Person.checkForEmailApIds(apIds))) {
            var sourceDomain = document.domain;
            document.domain = JV.UtilForEmail.getParentDomainName();
            var directAppIds = [];
            var agencyAppIds = [];
            $('.jv-directAppId').each(function (index) {
                directAppIds[index] = $(this).val();
            });
            $('.jv-agencyAppId').each(function (index) {
                agencyAppIds[index] = $(this).val();
            });
            if ($('#jv-rejectDIRECT').length == 0 && $('#jv-rejectAGENCY').length == 0) {
                //showing overlay content;
                $('#' + _modal.modalElement).jqmShow();
                _modal.bindQuickViewTooltip();
            }
            if ($('#jv-rejectDIRECT').length > 0) {
                JV.UtilForEmail.createOrUpdateTemplateIframe('rejectTemplateWidgetDirect');
                $('#rejectTemplateWidgetDirect').attr('src', window.jvbaseurl + 'Administrator/MessageFrameWidget.aspx?action=rejectframes&aid=' + directAppIds[0] + '&count=' + directAppIds.length);
                $('#rejectTemplateWidgetDirect').load(function () {

                    //checking for the direct candidate or through agency.
                    $('#jv-rejectDIRECT > .templateActualContainer').html($('#rejectTemplateWidgetDirect').contents().find('div#widgetContainer').html());
                    var emailTemplateObj = new EmailTemplateWidget({ 'id': 'messageFrameIdDirect', 'name': 'messageFrameClassDirect', 'tabindex': 5 },
                        { 'id': 'txtSubjectDirect', 'name': 'subject', 'tabindex': 6 },
                        { 'id': 'jv-mailContentDirect', 'name': 'message', 'tabindex': 7 });

                    emailTemplateObj.initialize();

                    //making default one to top.
                    var _defaultTemplate = $("#messageFrameIdDirect option[selected='selected']").text();
                    $("#messageFrameIdDirect option[selected='selected']").text(_defaultTemplate + '(Default)');
                    //showing overlay content;
                    $('#' + _modal.modalElement).jqmShow();
                    _modal.bindQuickViewTooltip();
                });
            }
            if ($('#jv-rejectAGENCY').length > 0) {
                JV.UtilForEmail.createOrUpdateTemplateIframe('rejectTemplateWidgetAgency');
                $('#rejectTemplateWidgetAgency').attr('src', window.jvbaseurl + 'Administrator/MessageFrameWidget.aspx?action=rejectframes&aid=' + agencyAppIds[0] + '&count=' + agencyAppIds.length);
                $('#rejectTemplateWidgetAgency').load(function () {

                    //checking for the direct candidate or through agency.
                    $('#jv-rejectAGENCY > .templateActualContainer').html('');
                    $('#jv-rejectAGENCY > .templateActualContainer').html($('#rejectTemplateWidgetAgency').contents().find('div#widgetContainer').html());
                    var emailTemplateObj = new EmailTemplateWidget({ 'id': 'messageFrameIdAgency', 'name': 'messageFrameClassAgency', 'tabindex': 5 },
                        { 'id': 'txtAgencySubjectAgency', 'name': 'subjectAgency', 'tabindex': 6 },
                        { 'id': 'jv-mailContentAgency', 'name': 'messageAgency', 'tabindex': 7 });

                    emailTemplateObj.initialize();

                    //making default one to top.
                    var _defaultTemplate = $("#messageFrameIdAgency option[selected='selected']").text();
                    $("#messageFrameIdAgency option[selected='selected']").text(_defaultTemplate + '(Default)');
                    //showing overlay content;
                    $('#' + _modal.modalElement).jqmShow();
                    _modal.bindQuickViewTooltip();
                    /*Resetting the document.domain back after we have fetched the iframe.
                      @TODO: Remove this eventually . Leaving this in as we are too close to the release
                    -NV Bug17290*/
                    document.domain = sourceDomain + '';
                });
            }

        }
        else {
            $('.jv-hideEmailOption').hide();
            $('#' + _modal.modalElement).jqmShow();
            _modal.bindQuickViewTooltip();
        }

    },

    renderEmailTemplateWidgetIframeforSM: function (content) {
        var me = this;
        var _modal = JV.Modal;
        //$($(content).find('#templateActualContainer').html(JV.Person.emailWidgetData));
        $('#' + _modal.modalElement).html(content);
        var sourceDomain = document.domain;
        document.domain = JV.UtilForEmail.getParentDomainName();
        JV.UtilForEmail.createOrUpdateTemplateIframe();
        //try{
        var apIds = JV.Person.getSelectedAppIds();
        $('#rejectTemplateWidget').attr('src', window.jvbaseurl + 'Administrator/MessageFrameWidget.aspx?action=sendMessage&aid=' + apIds[0] + '&index=5');
        $('#rejectTemplateWidget').load(function () {
            $('.templateActualContainer').html($('#rejectTemplateWidget').contents().find('div#widgetContainer').html());
            var emailTemplateObj = new EmailTemplateWidget({ 'id': 'messageFrameId', 'name': 'messageFrameClass', 'tabindex': '1' },
                { 'id': 'jv-mailSubject', 'name': 'subject', 'tabindex': '2' },
                { 'id': 'jv-mailContent', 'name': 'message', 'tabindex': '3' });

            emailTemplateObj.initialize();
            //making default one to top.
            var _defaultTemplate = $("#messageFrameId option[selected='selected']").text();
            $("#messageFrameId option[selected='selected']").text(_defaultTemplate + '(Default)');
            //showing overlay content;
            $('#' + _modal.modalElement).jqmShow();
            _modal.bindQuickViewTooltip();
            /*Resetting the document.domain back after we have fetched the iframe.
              @TODO: Remove this eventually. Leaving this in as we are too close to the release
            -NV Bug17290*/
            document.domain = sourceDomain + '';
        });

    },

    initializeVideoTab: function (applicationEId) {
        //http://stackoverflow.com/questions/19424357/angular-bootstrapping-after-load-of-html
        var injector = $('[ng-app]').injector();
        var $compile = injector.get('$compile');
        var content = $('div[ng-controller="QuickViewCtrl"]').html();
        $('div[ng-controller="QuickViewCtrl"]').html('');
        var linkFn = $compile(content);
        var $rootScope = injector.get('$rootScope');
        var elem = linkFn($rootScope);
        $('div[ng-controller="QuickViewCtrl"]').append(elem);
        $rootScope.$digest();
        JV.AngularUtils.broadcast('GET_QUICKVIEW_VIDEO_COUNT', applicationEId);
    }

}

/****

    All Angular implementation will be part of only this util.
    None of the angular code will be in the jquery code.

****/

var JV = JV || {};

JV.Util = {
    cacher: {},

    Const: {
        'OFCCP': i18n['JV_APPLICANT_SELECT_JOB_FOR_OFCCP_COMPLIANT_SEARCH'],
        'SELECT_JOB': i18n['JV_APPLICANT_SELECT_JOB'],
        'CANCEL': i18n['JV_APPLICANT_CANCEL'],
        'CONTINUE': i18n['JV_APPLICANT_CONTINUE'],
        'OFCCP_JOBSELECT_ERROR': i18n['JV_APPLICANT_YOU_MUST_SELECT_A_REQUISITION_TO_MEET_OFCCP_COMPLI'],
        'JOBSELECT_ERROR': i18n['JV_APPLICANT_YOU_MUST_SELECT_A_JOB_TO_PROCEED'],
        'SUBMIT_TO_HIRING_MANAGER': i18n['JV_APPLICANT_SUBMITTED_TO_HIRING_MANAGER'],
        'SELECTED_JOB': i18n['JV_APPLICANT_SELECTED_JOB_'],
        'NON_JOB_RELATED': i18n['JV_APPLICANT_NON_JOB_RELATED'],
        'FADE_TIME': 100,
        'DELAY_TIME': 4000
    },

    /**
     * Important attribute of args is the ajaxType which uniquely identifies what type of ajax request is being sent
     * to the backend.
     * Use Case: User can send multiple request for the same call. We want to avoid that as it can result in ambigious behavior.
     * The 'ajaxType' will abort the previous call made and make a new call for the  same ajax type.
     */
    makeAjaxRequest: function (args) {
        // clear the timeout.
        apiTimeoutClear();
        args.contentType = args.contentType ? args.contentType : 'application/x-www-form-urlencoded;charset=utf-8';
        args.type = 'POST';
        args.dataType = 'html';
        if (!!args.data) {
            args.data.enableHRUI = _HRTECHUI_ENABLED;
        }
        args.url = args.url ? args.url : JV.AJAX_URL;
        // if there is already an xhr request for the same action has been fired and it hasn't retured yet, abort it first and then make a new request.
        if (this.cacher[args.ajaxType]) {
            (this.cacher[args.ajaxType]).abort();
            this.cacher[args.ajaxType] = null;
        }
        // cache the ajax call
        if (typeof _gaq != 'undefined') {
            _gaq.push(['_trackEvent', JV.PAGE_TYPE, args.ajaxType ? args.ajaxType : 'unknown', 'Tracking']);
        }
        this.cacher[args.ajaxType] = $.ajax(args);
    },

    // Shows the given messages at the top of the grid and fades out within the given time of FADE_TIME.
    showMessage: function (message) {
        $('#' + JV.Person.elementConst['SUCCESS_MSG_ELEMENT']).show();
        $('#' + JV.Person.elementConst['SUCCESS_MSG_ELEMENT']).text(message).slideDown(this.Const['FADE_TIME']).delay(this.Const['DELAY_TIME']).slideUp(this.Const['FADE_TIME']);
    },

    // Shows the given error messages at the top of the grid and fades out within the given time of FADE_TIME.
    showErrorMessage: function (message) {
        var jqObject = $('.jv-showErrorMsg'),
            jqTrigger = $(document);
        jqTrigger.on('click', function handler() {
            jqTrigger.off('click', handler);
            jqObject.hide();
        });
        jqObject.text(message).show();
        JV.Person.resetValues();
    }
};

/**
 * The modal dialog boxes are complicated enough to create a seperate utility class for them.
 */

JV.Modal = {
    // modal dialog rendering element.
    modalElement: 'jv-modalDialog',
    elementConst: {
        OVERLAY_SORTBY: 'jv-overlaySortBy'
    },

    Const: {
        'LOADING': i18n['JV_APPLICANT_LOADING_']
    },

    //Initialize the modal dialog.
    initialize: function () {
        $.jqm.params.modal = true;
        this.attachEvent();
        $('#' + this.modalElement).jqm(); // initialization.
    },
    // Show the modal dialog
    render: function (params, callback, ifSlide) {
        var args = {};
        args.ajaxType = params.action;
        args.url = JV.AJAX_URL;
        if (callback) {
            args.success = callback;
        } else {
            args.success = function (content) {
                JV.Modal.show(content, ifSlide);
            };
        }

        args.data = params;
        JV.Util.makeAjaxRequest(args);
    },

    show: function (content, ifSlide) {
        $('#' + this.modalElement).html(content);
        $('#' + this.modalElement).jqmShow(ifSlide);
        //Vinoth: Quickview next steps overlay gets bounded only if its initialized here.
        this.bindQuickViewTooltip();
    },

    // Hide the modal dialog.
    hide: function () {
        $('#' + this.modalElement).css({ 'top': '', 'left': '' });
        $('#' + this.modalElement).jqmHide();
    },

    bindQuickViewTooltip: function () {
        //Vinoth: Specific IE7 positioning required hence checking for browser version.
        //Vinoth: As per JQuery API, $.browser is to be moved to a seperate plugin in next release,
        //hence using native JS to detect the browser version.
        var isIE7 = navigator.userAgent.indexOf('MSIE 7.0');
        if (isIE7 > 0) {
            $('.jv-WorkflowStatestatusLink').on('click', function () {
                var _id = $(this).parent().attr('id');
                var _position;
                if ($('.jv-status').length > 0) {
                    _position = $('.jv-status').parent().position();
                }
                $('.' + _id + 'quickviewNS').css({
                    'left': (_position.left - 100) + 'px',
                    'top': (_position.top + 84) + 'px',
                    'position': 'absolute',
                    'zIndex': 9999
                }).show();
                $('.' + _id + 'quickviewNS').mouseover(function () {
                    $('.' + _id + 'quickviewNS').show();
                }).mouseout(function () {
                    $('.' + _id + 'quickviewNS').hide();
                });
            });
            $('.appCount').on('click', function () {
                var _pos;
                if ($('.jv-candidateTitle').length > 0) {
                    _pos = $('.jv-candidateTitle').parent().position();
                }
                $('.jv-positionDetails').css({
                    'left': (_pos.left - 30) + 'px',
                    'top': (_pos.top + 95) + 'px',
                    'position': 'absolute',
                    'zIndex': 9999,
                    'display': 'block'
                });
                $('.jv-positionDetails').mouseover(function () {
                    $('.jv-positionDetails').show();
                }).mouseout(function () {
                    $('.jv-positionDetails').hide();
                });
                $('.jv-positionDetails').show();
            });
        } else {
            $('.tooltip2').jvtooltip({
                events: { def: 'click,mouseout' },
                relative: true
            }).dynamic();
        }
    },

    attachEvent: function () {
        var me = this;
        var _person = JV.Person;
        var _modal = JV.Modal;
        // For any cancel button attach the event to close the modal dialog box.
        // remember the cancel button should have the key as cancel(KEY='CANCEL')
        $("*[KEY='CANCEL']").on('click keydown', function (e) {
            var _process = false;
            if (e.type == 'keydown' && (e.which == 13 || e.keyCode == 13)) {
                _process = true;
            } else if (e.type != 'keydown') {
                _process = true;
            }
            if (_process) {
                _person.resetValues();
                if ($("FORM[name='jobForm']").length == 1) {
                    // Only do that  when the call is coming from job overlay. Otherwise dont do it.
                    $('#' + _person.elementConst['REQUISITION_ELEMENT']).val($('#' + _person.elementConst['REQUISITION_ELEMENT']).attr('PREVIOUS_VALUE'));
                }
                // remove the modal contents.
                me.hide();
                // just to remove the load of the DOM, in any case if the html is still inside.
                $('#' + me.modalElement).html('');
            }
            JV.Person.process('refreshSearchList');
        });


        /**
         * For any dropdown that needs an update for the grid create a key for that element and set it as
         * -> KEY='REFRESH_GRID'
         */
        $("*[KEY='REFRESH_GRID']").on('change', function () {
            _person['mode'] = null;
            if ($(this).attr('id') == 'requisitions') {
                $('#' + _person.elementConst['SELECTED_JOBID']).val('');
                me.hide();
                $(this).find('option:selected').each(function () {
                    if ($(this).val() <= 5) {
                        $('#requisitions').attr('name', 'requisitions');
                    } else {
                        //Vinoth: Setting the jobIds value to hidden field, since while navigating to
                        //details page the jobIds param is not getting passed to BE.
                        $('input[name=jobIds]').val($(this).val());
                        $('#requisitions').attr('name', 'jobIds');
                    }
                });
                _person.Global.grid.makeCallForGrid();
            } else if ($(this).attr('id') != 'requisitions') {
                me.hide();
                _person.Global.grid.makeCallForGrid();
            }
        });


        //Overlay Sorting
        $("*[KEY='OVERLAY_SORT']").on('click', function () {
            var _sortColumn = $(this).children().attr('id');
            var _currentSortBy = $('#' + _person.elementConst['OVERLAY_SORTBY']).val();
            if ((_sortColumn == _currentSortBy) && (_currentSortBy.indexOf('Desc') < 0)) {
                _sortColumn = _sortColumn + 'Desc';
            }
            $('#' + _person.elementConst['OVERLAY_SORTBY']).val(_sortColumn);
            var jobStateValue = $('#' + _person.elementConst['SEARCH_REQUISITION_ELEMENT']).val();
            var query = $('#' + _person.elementConst['SEARCH_TEXT_ELEMENT']).val();
            _modal.render({
                action: 'getJobs',
                sortBy: _sortColumn,
                jobStateValue: jobStateValue,
                q: query,
                overlayMode: JV.Person['mode']
            });
        });
    }
};

$(document).ready(function () {
    //navhighlight('CANDIDATES');
    var me = JV.Person;
    $(':checkbox').attr('autocomplete', 'off');
    //closing loading state once the dom is ready.
    $('#jv-loadingStateOverlay').hide();
    //Reset the default values on page loads.
    JV.Person.resetValues();
    me.initialize();
    $('#jv-modalDialog').jqDrag('.jqDrag');
    me.removeFadedText();
    me.removeColoredText();
    me.addFadedText();
    //if (q != '' || searchNamesOnly != '') {
    //$('#searchNamesOnly').attr('checked', searchNamesOnly);
    //$('#q').focus().val(q);
    //me.Global.grid.makeCallForGrid(function(){
    //JV.Person.process('refreshSearchList', '');
    //});
    //}
    // Tooltip
    $('.tooltip').jvtooltip({
        events: { def: 'click,mouseout' }
        //Vinoth: Removed position styling and added dynamic()
        // to position the tooltip based on <a>'s client area location.
    }).dynamic();
    $('.tooltipTh').jvtooltip({
        position: 'bottom center',
        offset: [10, 10]
    });

    JV.AngularUtils.attachListenersWithoutDeregister('TRIGGER_VIDEO_WORKFLOW_CHANGE', function (event, _arguments) {
        //VA: This gets triggered from angular scope and calls the 'reusable' showChangeToVideoWorkflowStateModal, which applies the scope again.
        // So trigger it out of the scope of angular world.
        var _args = _arguments;
        setTimeout(function () {
            JV.Person.showChangeToVideoWorkflowStateModal(_args.stateId, _args.workflowStateKind, undefined, _args.workflowStateName);
        }, 1);
    });

    JV.AngularUtils.attachListenersWithoutDeregister('VIDEO_SHOW_LOADING', function () {
        JV.Person.Global.grid.showLoadingState();
    });
    JV.AngularUtils.attachListenersWithoutDeregister('VIDEO_REMOVE_LOADING', function () {
        JV.Person.Global.grid.removeLoadingState();
    });

    JV.AngularUtils.attachListenersWithoutDeregister('INITIALIZE_VIDEO_TAB', function (appEId) {
        JV.Person.initializeVideoTab(appEId);
    });


});

// For navigations
function jvNavHeighlight() {
    navhighlight('CANDIDATES');
}

/*
 * Format a date String by stripping off the last token containing the time information.
 * Temporary method until we have a standard Javascript formatting method that can be invoked from a non-angular page.
 * @param dateString date in the format 'June 06, 2015 14:38:36'
 */
function formatDate(dateString) {
    // turn into a Javascript Date object
    var d = $.datepicker.parseDate('MM dd, yy', dateString);
    var formattedDate = $.datepicker.formatDate('DD, MM dd, yy', d);
    return formattedDate;
}

/* Distance change required as part of I18N */
/* Initializing the drop down values, basically as specified statically */
var distance = ['5', '10', '25', '50', '100'];

var sel = document.getElementById('distanceList');
if (sel) {
    for (var i = 0; i < distance.length; i++) {
        var opt = document.createElement('option'); /* Creation of select option drop down dynamically*/
        opt.innerHTML = distance[i] + ' ' + i18n[window._jvselfUser.locale.unitOfDistance];
        opt.value = distance[i];
        sel.appendChild(opt);
    }
}
